/* ==========================================
   CAPPED OUT - APPLICATION LOGIC & STATE
   ========================================== */

document.addEventListener('DOMContentLoaded', () => {
    // Check for clean embed mode in the URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const isEmbed = urlParams.get('embed') === 'true';
    if (isEmbed) {
        document.body.classList.add('embed-mode');
    }

    // === STATE & CART SETUP ===
    const state = {
        customizer: {
            step: 1,
            color: 'black',
            colorName: 'Black',
            bolt: 'none',
            boltName: 'No Bolt (Cap Only)',
            boltPrice: 0,
            packaging: false,
            designService: false,
            serviceInstructions: '',
            serviceFileName: '',
            basePrice: 30.00
        },
        cart: []
    };

    // Constant Finish Gradients
    const SVGGradients = {
        black: 'url(#finish-black)',
        green: 'url(#finish-green)',
        blue: 'url(#finish-blue)',
        gold: 'url(#finish-gold)',
        silver: 'url(#finish-silver)',
        bronze: 'url(#finish-bronze)',
        pink: 'url(#finish-pink)',
        purple: 'url(#finish-purple)',
        red: 'url(#finish-red)'
    };

    const SVGBolts = {
        black: 'url(#bolt-black)',
        oilslick: 'url(#bolt-oilslick)',
        gold: 'url(#bolt-gold)',
        blue: 'url(#bolt-blue)',
        pink: 'url(#bolt-pink)',
        bronze: 'url(#bolt-bronze)'
    };

    // Shopify Product Variant mapping for Cap + Bolt combinations
    const boltVariantMapping = {
        'none': '48971963531514',      // Cap Only
        'oilslick': '48971963564282',
        'gold': '48971963597050',
        'blue': '48971963629818',
        'black': '48971963662586',
        'pink': '48974934278394',
        'bronze': '48974934311162'
    };

    // Predefined Decal SVG Filenames (stored in Assets/Decals/)
    const DecalSVGFiles = {
        beer_can: 'Beer Can.svg',
        capped_out_skull: 'Capped Out Skull.svg',
        capped_out_skull_solid: 'Capped Out Skull v2.svg',
        crushed_beer_can: 'Crushed Beer Can.svg',
        sugar_skull: 'Sugar Skull.svg',
        tyre_track_1: 'Tyre Track 1.svg',
        tyre_track_2: 'Tyre Track 2.svg',
        bicycle_chain_skull: 'Bicycle Chain Skull.svg',
        mountain_gear: 'Mountain Gear.svg',
        hop_sprocket: 'Hop Sprocket.svg',
        lightning_bolt: 'Lightning Bolt.svg',
        mountain_range: 'Mountain Range.svg',
        kom_crown: 'KOM Crown.svg',
        chain_link: 'Chain Link.svg',
        speed_wings: 'Speed Wings.svg',
        compass: 'Compass.svg',
        premade_big_hucks: 'Big_Hucks_Zero_Fucks_v2.svg',
        premade_skull: 'Invader_v2.svg',
        premade_404: 'Dino_Game_v2.svg',
        premade_eject: 'Eject_Button_v2.svg',
        premade_send_it: 'Just_Fuckin_Send_It_v2.svg',
        premade_too_short: 'all_the_gear_v2.svg',
        premade_lets_go: 'Lets_Fuckin_Go.svg',
        premade_ride_fast_eat_ass: 'Ride_fast_Eat_Ass_v2.svg',
        premade_nugz: 'Nugz_Not_Drugz_v2.svg',
        premade_shut_up: 'Shut_Up_Legs.svg',
        premade_x_eyes: 'Smiley_v2.svg',
        premade_slappin_turns: 'Slappin_Turns_v2.svg',
        premade_mum_cool: 'My_Mum_Says_Im_Cool_v2.svg',
        premade_get_beers: 'Get_On_The_Beers.svg',
        premade_no_hands: 'Look_Mum_No_Hands.svg',
        premade_money_pit: 'Money_Pit.svg',
        premade_ready_shred: 'Ready_To_Shred.svg',
        premade_big_whips: 'Big_Whips.svg',
        premade_cookie: 'premade-cookie.jpg',
        premade_donut: 'premade-donut.jpg',
        premade_eyeball: 'premade-eyeball.jpg',
        premade_pizza: 'premade-pizza.jpg',
        premade_splatter_paint: 'premade-splatter-paint.jpg'
    };

    // === SELECTORS ===
    const navItems = document.querySelectorAll('.nav-item');
    const capBase = document.getElementById('custom-cap-base');
    const boltHead = document.getElementById('custom-bolt-head');
    
    // Customizer Elements
    const customizerCanvasEl = document.getElementById('customizer-canvas');
    const stepButtons = document.querySelectorAll('.w-step-btn');
    const panes = document.querySelectorAll('.wizard-pane');
    const prevBtn = document.getElementById('prev-step-btn');
    const nextBtn = document.getElementById('next-step-btn');
    const colorButtons = document.querySelectorAll('.color-option-btn');
    const tabButtons = document.querySelectorAll('.tab-btn');
    const tabPanes = document.querySelectorAll('.tab-pane');
    
    // Text Layer Controls
    const btnAddText = document.getElementById('btn-add-text');
    const textSettingsBox = document.getElementById('text-settings-box');
    const noSelectionPrompt = document.getElementById('no-selection-prompt');
    const editorTextContent = document.getElementById('editor-text-content');
    const editorFontSelect = document.getElementById('editor-font-select');
    const editorTextSize = document.getElementById('editor-text-size');
    const editorTextCurve = document.getElementById('editor-text-curve');
    const curveValueDisplay = document.getElementById('curve-value-display');
    const editorTextRotate = document.getElementById('editor-text-rotate');
    const rotateValueDisplay = document.getElementById('rotate-value-display');
    const liveCurveControlContainer = document.getElementById('live-curve-control-container');
    const liveEditorTextCurve = document.getElementById('live-editor-text-curve');
    const liveCurveValueDisplay = document.getElementById('live-curve-value-display');
    const liveEditorTextRotate = document.getElementById('live-editor-text-rotate');
    const liveRotateValueDisplay = document.getElementById('live-rotate-value-display');
    const liveEditorTextSize = document.getElementById('live-editor-text-size');
    const liveSizeValueDisplay = document.getElementById('live-size-value-display');
    const btnTextOutline = document.getElementById('btn-text-outline');
    const btnDeleteLayer = document.getElementById('btn-delete-layer');
    const liveBtnDeleteLayer = document.getElementById('live-btn-delete-layer');
    
    // Decals Controls
    const decalButtons = document.querySelectorAll('[data-preset-decal]');
    const decalFileInput = document.getElementById('decal-logo-file');
    const decalDropzone = document.getElementById('decal-dropzone');
    
    // Step 3 & 4 Options
    const boltCards = document.querySelectorAll('.bolt-option-card');
    const packagingCard = document.getElementById('packaging-upsell-card');
    const packagingCheckbox = document.getElementById('packaging-checkbox');
    const sumFinish = document.getElementById('sum-finish');
    const sumBolt = document.getElementById('sum-bolt');
    const sumPackaging = document.getElementById('sum-packaging');
    const boltPriceRow = document.getElementById('bolt-price-row');
    const sumBoltPrice = document.getElementById('sum-bolt-price');
    const packagingPriceRow = document.getElementById('packaging-price-row');
    const totalAmountSpan = document.getElementById('customizer-total-price');
    const addToCartBtn = document.getElementById('add-to-cart-btn');
    
    // Cart selectors
    const cartBtn = document.getElementById('cart-btn');
    const closeCartBtn = document.getElementById('close-cart');
    const cartOverlay = document.getElementById('cart-overlay');
    const cartDrawer = document.getElementById('cart-drawer');
    const cartItemsContainer = document.getElementById('cart-items-container');
    const cartCountBadges = document.querySelectorAll('.cart-count');
    const cartTotalQty = document.getElementById('cart-total-qty');
    const cartGrandTotalAmount = document.getElementById('cart-grand-total-amount');
    const checkoutBtn = document.getElementById('checkout-btn');

    // B2B Wholesale selectors
    const b2bQtyInput = document.getElementById('b2b-qty');
    const b2bQtyDecBtn = document.getElementById('b2b-qty-dec');
    const b2bQtyIncBtn = document.getElementById('b2b-qty-inc');
    const b2bCapColorSelect = document.getElementById('b2b-cap-color');
    const b2bBoltSelect = document.getElementById('b2b-bolt-type');
    const b2bForm = document.getElementById('b2b-calculator-form');
    const fileDropzone = document.getElementById('file-dropzone');

    let canvas = null;

    // === HELPER TOASTS ===
    function showToast(message, icon = 'fa-circle-check') {
        const toastContainer = document.getElementById('toast-container');
        if (!toastContainer) return;
        const toast = document.createElement('div');
        toast.className = 'toast';
        toast.innerHTML = `<i class="fa-solid ${icon}"></i> <span>${message}</span>`;
        toastContainer.appendChild(toast);
        
        setTimeout(() => {
            toast.style.animation = 'slideIn 0.3s ease reverse forwards';
            setTimeout(() => toast.remove(), 300);
        }, 3000);
    }

    // Dynamic price calculation helper
    function getCustomizerTotalPrice() {
        let total = state.customizer.basePrice;
        total += state.customizer.boltPrice;
        if (state.customizer.packaging) total += 10.00;
        if (state.customizer.designService) total += 10.00;
        return total;
    }

    // Dynamic Google Fonts CSS Loader
    function loadGoogleFont(fontName) {
        if (!fontName) return;
        const fontId = 'gfont-' + fontName.replace(/\s+/g, '-').toLowerCase();
        if (!document.getElementById(fontId)) {
            const link = document.createElement('link');
            link.id = fontId;
            link.rel = 'stylesheet';
            link.href = `https://fonts.googleapis.com/css2?family=${encodeURI(fontName)}:wght@400;700;900&display=swap`;
            document.head.appendChild(link);
        }
    }

    // === FABRIC.JS INTERACTIVE CANVAS SETUP ===
    try {
        if (customizerCanvasEl && typeof fabric !== 'undefined') {
            // Initialize Fabric.js Canvas
            canvas = new fabric.Canvas('customizer-canvas', {
                hoverCursor: 'pointer',
                selection: true,
                preserveObjectStacking: true
            });
            window.customizerCanvas = canvas; // Expose globally for design recovery script

            // === MULTI-TOUCH PINCH TO RESIZE SELECTED OBJECT ===
            const canvasWrapperEl = document.querySelector('.canvas-interactive-wrapper');
            if (canvasWrapperEl) {
                let touchStartDist = 0;
                let initialObjectScaleX = 1;
                let initialObjectScaleY = 1;
                let initialFontSize = 22;
                let activeObj = null;

                canvasWrapperEl.addEventListener('touchstart', function(e) {
                    if (e.touches.length === 2) {
                        activeObj = canvas.getActiveObject();
                        if (activeObj) {
                            e.preventDefault();
                            touchStartDist = Math.hypot(
                                e.touches[0].clientX - e.touches[1].clientX,
                                e.touches[0].clientY - e.touches[1].clientY
                            );
                            initialObjectScaleX = activeObj.scaleX || 1;
                            initialObjectScaleY = activeObj.scaleY || 1;
                            initialFontSize = activeObj.fontSize || 22;
                        }
                    }
                }, { passive: false });

                canvasWrapperEl.addEventListener('touchmove', function(e) {
                    if (e.touches.length === 2 && activeObj && touchStartDist > 0) {
                        e.preventDefault();
                        const currentDist = Math.hypot(
                            e.touches[0].clientX - e.touches[1].clientX,
                            e.touches[0].clientY - e.touches[1].clientY
                        );
                        
                        const scaleFactor = currentDist / touchStartDist;
                        if (activeObj.type === 'i-text') {
                            const newSize = Math.max(8, Math.min(64, Math.round(initialFontSize * scaleFactor)));
                            activeObj.set({ fontSize: newSize, scaleX: 1, scaleY: 1 });
                            if (activeObj.customCurvature) {
                                applyTextCurvature(activeObj, activeObj.customCurvature);
                            }
                            if (editorTextSize) editorTextSize.value = newSize;
                            if (liveEditorTextSize) liveEditorTextSize.value = newSize;
                            if (liveSizeValueDisplay) liveSizeValueDisplay.textContent = `${newSize}px`;
                        } else {
                            const baseScale = activeObj.baseScale || 1;
                            let newScale = initialObjectScaleX * scaleFactor;
                            newScale = Math.max(baseScale * 0.2, Math.min(newScale, baseScale * 2.5));
                            activeObj.set({
                                scaleX: newScale,
                                scaleY: newScale
                            });
                            const decalSlider = document.getElementById('decal-size-slider');
                            const decalDisplay = document.getElementById('decal-size-display');
                            const pct = Math.round((newScale / baseScale) * 100);
                            if (decalSlider) decalSlider.value = pct;
                            if (decalDisplay) decalDisplay.textContent = `${pct}%`;
                        }
                        
                        activeObj.setCoords();
                        canvas.renderAll();
                        if (typeof debouncedSaveDesign === 'function') {
                            debouncedSaveDesign();
                        } else if (typeof saveCurrentDesign === 'function') {
                            saveCurrentDesign();
                        }
                    }
                }, { passive: false });

                canvasWrapperEl.addEventListener('touchend', function(e) {
                    if (e.touches.length < 2) {
                        touchStartDist = 0;
                        activeObj = null;
                    }
                });
            }

            // Clear any stale design that was previously saved to localStorage (old behaviour).
            // Design saving now uses sessionStorage so it only persists within the current tab.
            try { localStorage.removeItem('cappedout_saved_design'); } catch (e) { /* ignore */ }

            // Debounce utility to prevent fast consecutive localStorage writes
            function debounce(func, wait) {
                let timeout;
                return function(...args) {
                    clearTimeout(timeout);
                    timeout = setTimeout(() => func.apply(this, args), wait);
                };
            }

            // Save design customizer configuration and canvas to browser localStorage
            function saveCurrentDesign() {
                if (!canvas) return;
                
                // Do not serialize canvas if user is actively editing text, to prevent lock-ups
                if (canvas.getObjects().some(obj => obj.isEditing)) {
                    return;
                }
                
                // Get Fabric canvas JSON including custom properties
                const canvasJSON = canvas.toJSON(['customCurvature', 'decalEtchMode', 'decalType', 'baseScale', 'isGuide']);
                if (canvasJSON && Array.isArray(canvasJSON.objects)) {
                    canvasJSON.objects = canvasJSON.objects.filter(o => !o.isGuide);
                }
                
                // Get current state configuration
                const designData = {
                    canvas: canvasJSON,
                    state: {
                        color: state.customizer.color,
                        colorName: state.customizer.colorName,
                        bolt: state.customizer.bolt,
                        boltName: state.customizer.boltName,
                        boltPrice: state.customizer.boltPrice,
                        packaging: state.customizer.packaging
                    }
                };
                
                try {
                    sessionStorage.setItem('cappedout_saved_design', JSON.stringify(designData));
                } catch (e) {
                    console.error("Failed to auto-save design to localStorage:", e);
                }
            }

            const debouncedSaveDesign = debounce(saveCurrentDesign, 500);
            const debouncedUpdateLayerDropdown = debounce(updateLayerDropdown, 200);

            // Set defaults: Enhanced touch handles for mobile & desktop precision
            fabric.Object.prototype.set({
                hasControls: true,
                hasBorders: true,
                borderColor: '#ff0033',
                cornerColor: '#ff0033',
                cornerStrokeColor: '#07070a',
                cornerStyle: 'circle',
                cornerSize: 14,
                touchCornerSize: 32,
                transparentCorners: false,
                padding: 8,
                borderScaleFactor: 2,
                lockUniScaling: true
            });
            if (fabric.Object.prototype.setControlsVisibility) {
                fabric.Object.prototype.setControlsVisibility({
                    mt: false,
                    mb: false,
                    ml: false,
                    mr: false
                });
            }

            // Clip Canvas to the outer circular boundaries of the stem cap
            canvas.clipPath = new fabric.Circle({
                radius: 135,
                left: 135,
                top: 135,
                originX: 'center',
                originY: 'center',
                absolutePositioned: true
            });

            // Set laser etch color based on cap finish (always white as laser cannot produce black)
            const getEtchColor = () => {
                return '#ffffff';
            };

            // Add Default Curved-like placement items to canvas on setup
            const defaultText1 = new fabric.IText('CUSTOM TEXT', {
                left: 135,
                top: 55,
                fontSize: 22,
                fontFamily: 'Outfit',
                fontWeight: '900',
                fill: getEtchColor(),
                originX: 'center',
                originY: 'center',
                charSpacing: 150
            });

            const defaultText2 = new fabric.IText('SHRED IT!', {
                left: 135,
                top: 215,
                fontSize: 22,
                fontFamily: 'Outfit',
                fontWeight: '900',
                fill: getEtchColor(),
                originX: 'center',
                originY: 'center',
                charSpacing: 150
            });

            canvas.add(defaultText1);
            canvas.add(defaultText2);
            canvas.renderAll();
            
            // Update layers dropdown lists on startup
            setTimeout(updateLayerDropdown, 200);

            // Monitor Selection Events to Toggle Control Panel
            canvas.on('selection:created', onObjectSelected);
            canvas.on('selection:updated', onObjectSelected);
            canvas.on('selection:cleared', onObjectCleared);
            
            // Refresh options list and auto-save design when layers change or text changes inside
            canvas.on('object:added', () => {
                debouncedUpdateLayerDropdown();
                debouncedSaveDesign();
            });
            canvas.on('object:removed', () => {
                debouncedUpdateLayerDropdown();
                debouncedSaveDesign();
            });
            canvas.on('text:changed', () => {
                debouncedUpdateLayerDropdown();
                debouncedSaveDesign();
            });
            canvas.on('object:modified', () => {
                debouncedSaveDesign();
            });

            // Magnetic center snap guidelines & bolt-hole safe zone helper
            function updateSnapGuides(showX, showY) {
                if (!canvas) return;
                let guideX = canvas.getObjects().find(o => o.id === 'snap-guide-x');
                let guideY = canvas.getObjects().find(o => o.id === 'snap-guide-y');

                if (showX) {
                    if (!guideX) {
                        guideX = new fabric.Line([135, 0, 135, 270], {
                            id: 'snap-guide-x',
                            isGuide: true,
                            stroke: '#ff0033',
                            strokeWidth: 1,
                            strokeDashArray: [4, 4],
                            selectable: false,
                            evented: false
                        });
                        canvas.add(guideX);
                    }
                    guideX.bringToFront();
                } else if (guideX) {
                    canvas.remove(guideX);
                }

                if (showY) {
                    if (!guideY) {
                        guideY = new fabric.Line([0, 135, 270, 135], {
                            id: 'snap-guide-y',
                            isGuide: true,
                            stroke: '#ff0033',
                            strokeWidth: 1,
                            strokeDashArray: [4, 4],
                            selectable: false,
                            evented: false
                        });
                        canvas.add(guideY);
                    }
                    guideY.bringToFront();
                } else if (guideY) {
                    canvas.remove(guideY);
                }
            }

            function clearAllGuides() {
                if (!canvas) return;
                const guides = canvas.getObjects().filter(o => o.isGuide || o.id === 'curvature-guide' || o.id === 'snap-guide-x' || o.id === 'snap-guide-y');
                guides.forEach(g => canvas.remove(g));
            }

            // Update stored flat center and apply magnetic center snapping when objects are moved
            canvas.on('object:moving', (e) => {
                const target = e.target;
                if (!target) return;

                const SNAP_DIST = 5;
                let snappedX = false;
                let snappedY = false;

                if (Math.abs(target.left - 135) < SNAP_DIST) {
                    target.set('left', 135);
                    snappedX = true;
                }
                if (Math.abs(target.top - 135) < SNAP_DIST) {
                    target.set('top', 135);
                    snappedY = true;
                }
                updateSnapGuides(snappedX, snappedY);

                if (target.type === 'i-text') {
                    const val = target.customCurvature || 0;
                    const center = target.getCenterPoint();
                    if (val === 0) {
                        target._flatCenter = center;
                    } else {
                        const R = 90;
                        let wrapDeg = Math.abs(val);
                        if (wrapDeg > 359.9) wrapDeg = 359.9;
                        if (wrapDeg < 2) wrapDeg = 2;
                        const theta = (wrapDeg / 360) * 2 * Math.PI;
                        const bboxCenterY = Math.sign(val) * (45 - 45 * Math.cos(theta / 2));
                        const alpha = (target.angle || 0) * Math.PI / 180;
                        target._flatCenter = new fabric.Point(
                            center.x + bboxCenterY * Math.sin(alpha),
                            center.y - bboxCenterY * Math.cos(alpha)
                        );
                    }
                }
            });

            canvas.on('mouse:up', () => {
                updateSnapGuides(false, false);
            });

            // Sync rotation sliders when rotating object on canvas
            canvas.on('object:rotating', (e) => {
                const activeObj = e.target;
                if (!activeObj) return;
                let rotValue = Math.round(activeObj.angle || 0);
                if (rotValue > 180) rotValue -= 360;
                if (activeObj.type === 'i-text') {
                    if (editorTextRotate) editorTextRotate.value = rotValue;
                    if (rotateValueDisplay) rotateValueDisplay.textContent = `${rotValue}°`;
                    if (liveEditorTextRotate) liveEditorTextRotate.value = rotValue;
                    if (liveRotateValueDisplay) liveRotateValueDisplay.textContent = `${rotValue}°`;
                } else {
                    const decalRotSlider = document.getElementById('decal-rotate-slider');
                    const decalRotDisplay = document.getElementById('decal-rotate-display');
                    if (decalRotSlider) decalRotSlider.value = rotValue;
                    if (decalRotDisplay) decalRotDisplay.textContent = `${rotValue}°`;
                }
            });

            function applyTextCurvature(activeObj, val) {
                if (!activeObj._flatCenter) {
                    activeObj._flatCenter = activeObj.getCenterPoint();
                }

                if (!val || val === 0) {
                    activeObj.set({
                        path: null,
                        charSpacing: 150
                    });
                    activeObj.setPositionByOrigin(activeObj._flatCenter, 'center', 'center');
                    activeObj.setCoords();
                    canvas.renderAll();
                    return;
                }
                
                // Get the length of the string to adjust radius dynamically
                const textLength = activeObj.text ? activeObj.text.length : 1;
                
                // Adjust radius based on text length: longer text gets a wider radius to avoid tight overlaps
                // Base radius of 90 is adjusted to grow slightly for longer strings (roughly 8px per character above 8 chars)
                const baseR = 90;
                const R = textLength > 8 ? baseR + (textLength - 8) * 8 : baseR;
                
                let wrapDeg = Math.abs(val);
                if (wrapDeg > 359.9) wrapDeg = 359.9;
                if (wrapDeg < 2) wrapDeg = 2;
                
                const theta = (wrapDeg / 360) * 2 * Math.PI;
                
                let cx = 0;
                let cy = 0;
                let startAngle, endAngle;
                let sweep;
                
                if (val > 0) {
                    cx = 0;
                    cy = R; // center of circle is below text
                    startAngle = 1.5 * Math.PI - (theta / 2);
                    endAngle = 1.5 * Math.PI + (theta / 2);
                    sweep = 1;
                } else {
                    cx = 0;
                    cy = -R; // center of circle is above text
                    startAngle = 0.5 * Math.PI + (theta / 2);
                    endAngle = 0.5 * Math.PI - (theta / 2);
                    sweep = 0;
                }
                
                const startX = cx + R * Math.cos(startAngle);
                const startY = cy + R * Math.sin(startAngle);
                const endX = cx + R * Math.cos(endAngle);
                const endY = cy + R * Math.sin(endAngle);
                
                const largeArc = wrapDeg > 180 ? 1 : 0;
                const pathStr = `M ${startX},${startY} A ${R},${R} 0 ${largeArc},${sweep} ${endX},${endY}`;
                
                const fabricPath = new fabric.Path(pathStr, {
                    fill: 'transparent',
                    stroke: 'transparent'
                });

                // Reduce spacingFactor scaling to avoid spread-out styling on wide layouts
                const spacingFactor = 100 + Math.round((wrapDeg / 360) * 150);
                
                activeObj.set({
                    path: fabricPath,
                    charSpacing: spacingFactor,
                    textAlign: 'center'
                });
                
                // Keep the text object anchored at its flat center point.
                // Since the path coordinates range from minY to maxY, the center of the bounding box is (minY + maxY)/2.
                // We compute the exact offset of the bounding box center relative to the local origin (0,0).
                const bboxCenterY = Math.sign(val) * (R - R * Math.cos(theta / 2));
                const alpha = (activeObj.angle || 0) * Math.PI / 180;
                
                // Offset the center coordinate so the midpoint of the text is locked at _flatCenter
                const targetCenterX = activeObj._flatCenter.x - bboxCenterY * Math.sin(alpha);
                const targetCenterY = activeObj._flatCenter.y + bboxCenterY * Math.cos(alpha);
                
                activeObj.setPositionByOrigin(new fabric.Point(targetCenterX, targetCenterY), 'center', 'center');
                activeObj.setCoords();
                canvas.renderAll();
            }

            const localFonts = ['Another Danger', 'Another Danger Slanted', 'Chalk Board', 'Die Die Die', 'Road Rage'];

            const layerSelectDropdown = document.getElementById('layer-select-dropdown');

            const quickLayerChipsContainer = document.getElementById('quick-layer-chips-container');

            function updateLayerDropdown() {
                if (layerSelectDropdown) {
                    layerSelectDropdown.innerHTML = '<option value="">-- Choose Layer to Edit --</option>';
                }
                if (quickLayerChipsContainer) {
                    quickLayerChipsContainer.innerHTML = '';
                }
                
                const activeObj = canvas.getActiveObject();
                const objects = canvas.getObjects();
                
                objects.forEach((obj, idx) => {
                    if (obj.isGuide || obj.id === 'curvature-guide' || obj.id === 'snap-guide-x' || obj.id === 'snap-guide-y') return;
                    let label = `Layer ${idx + 1}: `;
                    let shortLabel = `L${idx + 1}`;
                    let iconClass = 'fa-shapes';
                    if (obj.type === 'i-text') {
                        label += `Text (${obj.text.substring(0, 12)})`;
                        shortLabel = `"${obj.text.substring(0, 8)}"`;
                        iconClass = 'fa-font';
                    } else if (obj.type === 'path' || obj.type === 'group') {
                        label += `Decal Graphic`;
                        shortLabel = `Graphic`;
                        iconClass = 'fa-image';
                    } else if (obj.type === 'image') {
                        label += `Custom Upload`;
                        shortLabel = `Image`;
                        iconClass = 'fa-cloud-arrow-up';
                    } else {
                        label += `Object`;
                    }
                    
                    if (layerSelectDropdown) {
                        const option = document.createElement('option');
                        option.value = idx;
                        option.textContent = label;
                        if (activeObj === obj) {
                            option.selected = true;
                        }
                        layerSelectDropdown.appendChild(option);
                    }

                    if (quickLayerChipsContainer) {
                        const chip = document.createElement('button');
                        chip.type = 'button';
                        chip.className = 'layer-chip-btn' + (activeObj === obj ? ' active' : '');
                        chip.innerHTML = `<i class="fa-solid ${iconClass}"></i> <span>${shortLabel}</span>`;
                        chip.style.cssText = `
                            padding: 0.35rem 0.65rem;
                            border-radius: 20px;
                            font-size: 0.72rem;
                            font-weight: 700;
                            border: 1px solid ${activeObj === obj ? '#ff0033' : 'var(--border-color)'};
                            background: ${activeObj === obj ? 'rgba(255, 0, 51, 0.15)' : 'rgba(255, 255, 255, 0.04)'};
                            color: ${activeObj === obj ? '#ff335c' : 'var(--text-main)'};
                            display: inline-flex;
                            align-items: center;
                            gap: 0.35rem;
                            cursor: pointer;
                            white-space: nowrap;
                            flex-shrink: 0;
                            transition: all 0.2s ease;
                        `;
                        chip.addEventListener('click', () => {
                            canvas.setActiveObject(obj);
                            canvas.renderAll();
                        });
                        quickLayerChipsContainer.appendChild(chip);
                    }
                });
            }

            if (layerSelectDropdown) {
                layerSelectDropdown.addEventListener('change', (e) => {
                    const idx = e.target.value;
                    if (idx !== "") {
                        const obj = canvas.getObjects()[parseInt(idx)];
                        if (obj) {
                            canvas.setActiveObject(obj);
                            canvas.renderAll();
                        }
                    } else {
                        canvas.discardActiveObject();
                        canvas.renderAll();
                    }
                });
            }



            function syncActiveDesigningStickyState(forceActive = false) {
                const previewContainer = document.querySelector('.customizer-preview-container');
                if (!previewContainer) return;
                const hasActiveObj = !!(canvas && canvas.getActiveObject());
                const isStep2 = state && state.customizer && state.customizer.step === 2;
                const shouldStick = forceActive || isStep2 || hasActiveObj;
                previewContainer.classList.toggle('is-actively-designing', shouldStick);
            }
            window.syncActiveDesigningStickyState = syncActiveDesigningStickyState;

            // Activate sticky preview immediately whenever any slider or control inside the designer is interacted with
            const controlsContainer = document.querySelector('.customizer-controls-container');
            if (controlsContainer) {
                ['input', 'pointerdown', 'touchstart', 'focusin'].forEach(evtName => {
                    controlsContainer.addEventListener(evtName, (evt) => {
                        if (evt.target && (evt.target.matches('input[type="range"], #editor-text-content, .btn-nudge-dir, .btn-nudge-center, .layer-chip-btn, #layer-select-dropdown') || evt.target.closest('#text-settings-box'))) {
                            syncActiveDesigningStickyState(true);
                        }
                    }, { passive: true });
                });
            }

            function onObjectSelected(e) {
                const activeObj = e.selected[0];
                updateLayerDropdown();
                syncActiveDesigningStickyState();
                
                if (activeObj && activeObj.type === 'i-text') {
                    noSelectionPrompt.style.display = 'none';
                    textSettingsBox.style.display = 'block';
                    
                    // Show desktop text controls, hide decal controls
                    const desktopTextControls = document.getElementById('desktop-text-controls');
                    const desktopDecalControls = document.getElementById('desktop-decal-controls');
                    const editEtchTitle = textSettingsBox.querySelector('h4');
                    if (editEtchTitle) editEtchTitle.textContent = 'Edit Text Layer';
                    if (desktopTextControls) desktopTextControls.style.display = 'block';
                    if (desktopDecalControls) desktopDecalControls.style.display = 'none';
                    
                    // Show mobile text tools
                    const mNoSelection = document.getElementById('mobile-text-no-selection');
                    const mEditorControls = document.getElementById('mobile-text-editor-controls');
                    const mDecalEditorControls = document.getElementById('mobile-decal-editor-controls');
                    if (mNoSelection) mNoSelection.style.display = 'none';
                    if (mEditorControls) mEditorControls.style.display = 'block';
                    if (mDecalEditorControls) mDecalEditorControls.style.display = 'none';
                    
                    // If on mobile, auto-switch the mobile toolbox to the "Text" tab
                    const mTextTabBtn = document.querySelector('[data-mobile-tab="m-tab-text"]');
                    if (mTextTabBtn && window.innerWidth <= 768) {
                        mTextTabBtn.click();
                    }
                    
                    // Populate editor fields
                    editorTextContent.value = activeObj.text;
                    const mEditorTextContent = document.getElementById('mobile-editor-text-content');
                    if (mEditorTextContent) {
                        mEditorTextContent.value = activeObj.text;
                    }

                    if (editorFontSelect) {
                        editorFontSelect.value = activeObj.fontFamily;
                        // Update custom trigger button display
                        const selectedFontNameEl = document.getElementById('selected-font-name');
                        const mobileSelectedFontNameEl = document.getElementById('mobile-selected-font-name');
                        if (selectedFontNameEl) {
                            selectedFontNameEl.textContent = activeObj.fontFamily;
                            selectedFontNameEl.style.fontFamily = activeObj.fontFamily;
                        }
                        if (mobileSelectedFontNameEl) {
                            mobileSelectedFontNameEl.textContent = activeObj.fontFamily;
                            mobileSelectedFontNameEl.style.fontFamily = activeObj.fontFamily;
                        }
                        // Update active class in custom list options
                        document.querySelectorAll('.font-option').forEach(opt => {
                            if (opt.dataset.font === activeObj.fontFamily) {
                                opt.classList.add('active');
                            } else {
                                opt.classList.remove('active');
                            }
                        });
                    }
                    editorTextSize.value = activeObj.fontSize;
                    if (liveEditorTextSize) {
                        liveEditorTextSize.value = activeObj.fontSize;
                    }
                    if (liveSizeValueDisplay) {
                        liveSizeValueDisplay.textContent = `${activeObj.fontSize}px`;
                    }
                    
                    // Curvature Sync
                    const curValue = activeObj.customCurvature || 0;
                    if (editorTextCurve) {
                        editorTextCurve.value = curValue;
                        curveValueDisplay.textContent = curValue === 0 ? '0 (Flat)' : (curValue > 0 ? `+${curValue}` : curValue);
                    }
                    
                    // Rotation Sync
                    const rotValue = Math.round(activeObj.angle || 0);
                    if (editorTextRotate) {
                        editorTextRotate.value = rotValue;
                        if (rotateValueDisplay) {
                            rotateValueDisplay.textContent = `${rotValue}°`;
                        }
                    }
                    
                    // Sync outline button styling
                    const isOutline = !!activeObj.stroke;
                    btnTextOutline.classList.toggle('active', isOutline);
                    const mobileBtnOutline = document.getElementById('mobile-btn-text-outline');
                    if (mobileBtnOutline) {
                        mobileBtnOutline.classList.toggle('active', isOutline);
                    }
                    
                    if (liveCurveControlContainer) {
                        // Desktop: only show if display is not overridden by mobile layout
                        if (window.innerWidth > 768) {
                            liveCurveControlContainer.style.display = 'block';
                        }
                        if (liveEditorTextCurve) {
                            liveEditorTextCurve.value = curValue;
                        }
                        if (liveCurveValueDisplay) {
                            liveCurveValueDisplay.textContent = curValue === 0 ? '0 (Flat)' : (curValue > 0 ? `+${curValue}` : curValue);
                        }
                        if (liveEditorTextRotate) {
                            liveEditorTextRotate.value = rotValue;
                        }
                        if (liveRotateValueDisplay) {
                            liveRotateValueDisplay.textContent = `${rotValue}°`;
                        }
                        if (liveEditorTextSize) {
                            liveEditorTextSize.value = activeObj.fontSize;
                        }
                        if (liveSizeValueDisplay) {
                            liveSizeValueDisplay.textContent = `${activeObj.fontSize}px`;
                        }
                    }
                } else if (activeObj) {
                    noSelectionPrompt.style.display = 'none';
                    textSettingsBox.style.display = 'block';
                    
                    // Show desktop decal controls, hide text controls
                    const desktopTextControls = document.getElementById('desktop-text-controls');
                    const desktopDecalControls = document.getElementById('desktop-decal-controls');
                    const editEtchTitle = textSettingsBox.querySelector('h4');
                    if (editEtchTitle) editEtchTitle.textContent = 'Edit Graphic Layer';
                    if (desktopTextControls) desktopTextControls.style.display = 'none';
                    if (desktopDecalControls) desktopDecalControls.style.display = 'block';
                    
                    // Show mobile decal tools
                    const mNoSelection = document.getElementById('mobile-text-no-selection');
                    const mEditorControls = document.getElementById('mobile-text-editor-controls');
                    const mDecalEditorControls = document.getElementById('mobile-decal-editor-controls');
                    if (mNoSelection) mNoSelection.style.display = 'none';
                    if (mEditorControls) mEditorControls.style.display = 'none';
                    if (mDecalEditorControls) mDecalEditorControls.style.display = 'block';
                    
                    // If on mobile, auto-switch the mobile toolbox to the "Text" tab
                    const mTextTabBtn = document.querySelector('[data-mobile-tab="m-tab-text"]');
                    if (mTextTabBtn && window.innerWidth <= 768) {
                        mTextTabBtn.click();
                    }

                    // Sync outline button styling
                    const isOutline = activeObj.decalEtchMode === 'line';
                    const btnDecalOutline = document.getElementById('btn-decal-outline');
                    const mobileBtnDecalOutline = document.getElementById('mobile-btn-decal-outline');
                    if (btnDecalOutline) btnDecalOutline.classList.toggle('active', isOutline);
                    if (mobileBtnDecalOutline) mobileBtnDecalOutline.classList.toggle('active', isOutline);

                    // Sync relative decal size & rotation sliders
                    if (!activeObj.baseScale) {
                        activeObj.baseScale = Math.abs(activeObj.scaleX) || 1;
                    }
                    const decalSlider = document.getElementById('decal-size-slider');
                    const decalDisplay = document.getElementById('decal-size-display');
                    const relScalePct = Math.round((Math.abs(activeObj.scaleX || 1) / activeObj.baseScale) * 100);
                    if (decalSlider) decalSlider.value = Math.max(20, Math.min(250, relScalePct));
                    if (decalDisplay) decalDisplay.textContent = `${relScalePct}%`;

                    let decalRot = Math.round(activeObj.angle || 0);
                    if (decalRot > 180) decalRot -= 360;
                    const decalRotSlider = document.getElementById('decal-rotate-slider');
                    const decalRotDisplay = document.getElementById('decal-rotate-display');
                    if (decalRotSlider) decalRotSlider.value = decalRot;
                    if (decalRotDisplay) decalRotDisplay.textContent = `${decalRot}°`;

                    if (liveCurveControlContainer && window.innerWidth > 768) {
                        liveCurveControlContainer.style.display = 'none';
                    }
                }
            }

            function onObjectCleared() {
                updateLayerDropdown();
                syncActiveDesigningStickyState();
                noSelectionPrompt.style.display = 'block';
                textSettingsBox.style.display = 'none';
                
                const mNoSelection = document.getElementById('mobile-text-no-selection');
                const mEditorControls = document.getElementById('mobile-text-editor-controls');
                const mDecalEditorControls = document.getElementById('mobile-decal-editor-controls');
                if (mNoSelection) mNoSelection.style.display = 'block';
                if (mEditorControls) mEditorControls.style.display = 'none';
                if (mDecalEditorControls) mDecalEditorControls.style.display = 'none';

                if (liveCurveControlContainer && window.innerWidth > 768) {
                    liveCurveControlContainer.style.display = 'none';
                }
            }

            // Keyboard listener for deletion
            window.addEventListener('keydown', (e) => {
                if (document.activeElement && (
                    document.activeElement.tagName === 'INPUT' || 
                    document.activeElement.tagName === 'TEXTAREA' || 
                    document.activeElement.isContentEditable
                )) {
                    return;
                }
                
                if (e.key === 'Delete' || e.key === 'Backspace') {
                    const activeObj = canvas.getActiveObject();
                    if (activeObj && !activeObj.isEditing) {
                        e.preventDefault();
                        canvas.remove(activeObj);
                        canvas.discardActiveObject();
                        canvas.renderAll();
                        onObjectCleared();
                        showToast('Etch layer deleted.', 'fa-trash-can');
                    }
                }
            });

            // Text input editor listener
            editorTextContent.addEventListener('input', (e) => {
                const activeObj = canvas.getActiveObject();
                if (activeObj && activeObj.type === 'i-text') {
                    activeObj.set('text', e.target.value);
                    canvas.renderAll();
                    if (activeObj.customCurvature) {
                        applyTextCurvature(activeObj, activeObj.customCurvature);
                    }
                    debouncedSaveDesign();
                }
            });

            // Font Size slider listener
            editorTextSize.addEventListener('input', (e) => {
                const activeObj = canvas.getActiveObject();
                if (activeObj) {
                    const sizeVal = parseInt(e.target.value);
                    activeObj.set('fontSize', sizeVal);
                    canvas.renderAll();
                    if (liveEditorTextSize) {
                        liveEditorTextSize.value = sizeVal;
                    }
                    if (liveSizeValueDisplay) {
                        liveSizeValueDisplay.textContent = `${sizeVal}px`;
                    }
                    if (activeObj.type === 'i-text' && activeObj.customCurvature) {
                        applyTextCurvature(activeObj, activeObj.customCurvature);
                    }
                    debouncedSaveDesign();
                }
            });

            // Live Font Size slider listener (under preview)
            if (liveEditorTextSize) {
                liveEditorTextSize.addEventListener('input', (e) => {
                    const activeObj = canvas.getActiveObject();
                    if (activeObj) {
                        const sizeVal = parseInt(e.target.value);
                        activeObj.set('fontSize', sizeVal);
                        canvas.renderAll();
                        if (editorTextSize) {
                            editorTextSize.value = sizeVal;
                        }
                        if (liveSizeValueDisplay) {
                            liveSizeValueDisplay.textContent = `${sizeVal}px`;
                        }
                        if (activeObj.type === 'i-text' && activeObj.customCurvature) {
                            applyTextCurvature(activeObj, activeObj.customCurvature);
                        }
                        debouncedSaveDesign();
                    }
                });
            }

            // Curvature Guide Helpers for visual alignment while wrapping
            function showCurvatureGuide() {
                if (!canvas) return;
                const activeObj = canvas.getActiveObject();
                if (!activeObj || activeObj.type !== 'i-text') return;

                let guide = canvas.getObjects().find(obj => obj.id === 'curvature-guide');
                if (!guide) {
                    guide = new fabric.Circle({
                        id: 'curvature-guide',
                        radius: 90,
                        fill: 'transparent',
                        stroke: '#ff0033', // brand red accent color matching the site theme
                        strokeWidth: 1.5,
                        strokeDashArray: [6, 4], // dotted path
                        selectable: false,
                        evented: false,
                        originX: 'center',
                        originY: 'center'
                    });
                    canvas.add(guide);
                }

                // The path cx, cy are at 110, 110. The text is drawn with respect to this path.
                // In Fabric.js, when a path is applied to text, the object's dimensions and origin shift.
                // To position the guide circle so it matches the text's wrap path exactly:
                // When path is applied, the center of the arc path (110, 110) corresponds to a point
                // that is aligned with the text's origin. Let's calculate the absolute coordinate of the path center.
                // When we wrap text, the text is bound to the path of radius 90.
                // Let's set the guide's position to match the active object's center/top/left relative adjustments.
                // The circle guide is anchored at the exact center of the physical stem cap (135, 135)
                // so the user has a stable circular path of radius 90 relative to the cap.
                guide.set({
                    left: 135,
                    top: 135,
                    angle: 0
                });
                
                guide.sendToBack();
                canvas.renderAll();
            }

            function hideCurvatureGuide() {
                if (!canvas) return;
                const guide = canvas.getObjects().find(obj => obj.id === 'curvature-guide');
                if (guide) {
                    canvas.remove(guide);
                    canvas.renderAll();
                }
            }

            // Curvature sidebar slider listener
            if (editorTextCurve) {
                editorTextCurve.addEventListener('input', (e) => {
                    const activeObj = canvas.getActiveObject();
                    if (activeObj && activeObj.type === 'i-text') {
                        const val = parseInt(e.target.value);
                        activeObj.customCurvature = val;
                        
                        showCurvatureGuide();
                        
                        if (curveValueDisplay) {
                            curveValueDisplay.textContent = val === 0 ? '0 (Flat)' : (val > 0 ? `+${val}` : val);
                        }
                        if (liveEditorTextCurve) {
                            liveEditorTextCurve.value = val;
                        }
                        if (liveCurveValueDisplay) {
                            liveCurveValueDisplay.textContent = val === 0 ? '0 (Flat)' : (val > 0 ? `+${val}` : val);
                        }
                        applyTextCurvature(activeObj, val);
                        debouncedSaveDesign();
                    }
                });

                editorTextCurve.addEventListener('change', () => {
                    hideCurvatureGuide();
                });
            }

            // Live Curvature (under preview) slider listener
            if (liveEditorTextCurve) {
                liveEditorTextCurve.addEventListener('input', (e) => {
                    const activeObj = canvas.getActiveObject();
                    if (activeObj && activeObj.type === 'i-text') {
                        const val = parseInt(e.target.value);
                        activeObj.customCurvature = val;
                        
                        showCurvatureGuide();
                        
                        if (liveCurveValueDisplay) {
                            liveCurveValueDisplay.textContent = val === 0 ? '0 (Flat)' : (val > 0 ? `+${val}` : val);
                        }
                        if (editorTextCurve) {
                            editorTextCurve.value = val;
                        }
                        if (curveValueDisplay) {
                            curveValueDisplay.textContent = val === 0 ? '0 (Flat)' : (val > 0 ? `+${val}` : val);
                        }
                        applyTextCurvature(activeObj, val);
                        debouncedSaveDesign();
                    }
                });

                liveEditorTextCurve.addEventListener('change', () => {
                    hideCurvatureGuide();
                });
            }

            // Rotation sidebar slider listener
            if (editorTextRotate) {
                editorTextRotate.addEventListener('input', (e) => {
                    const activeObj = canvas.getActiveObject();
                    if (activeObj) {
                        const val = parseInt(e.target.value);
                        activeObj.set('angle', val);
                        activeObj.setCoords();
                        canvas.renderAll();
                        
                        if (rotateValueDisplay) {
                            rotateValueDisplay.textContent = `${val}°`;
                        }
                        if (liveEditorTextRotate) {
                            liveEditorTextRotate.value = val;
                        }
                        if (liveRotateValueDisplay) {
                            liveRotateValueDisplay.textContent = `${val}°`;
                        }
                        debouncedSaveDesign();
                    }
                });
            }

            // Live Rotation (under preview) slider listener
            if (liveEditorTextRotate) {
                liveEditorTextRotate.addEventListener('input', (e) => {
                    const activeObj = canvas.getActiveObject();
                    if (activeObj) {
                        const val = parseInt(e.target.value);
                        activeObj.set('angle', val);
                        activeObj.setCoords();
                        canvas.renderAll();
                        
                        if (liveRotateValueDisplay) {
                            liveRotateValueDisplay.textContent = `${val}°`;
                        }
                        if (editorTextRotate) {
                            editorTextRotate.value = val;
                        }
                        if (rotateValueDisplay) {
                            rotateValueDisplay.textContent = `${val}°`;
                        }
                        debouncedSaveDesign();
                    }
                });
            }

            // Font selection drop-down list change event listener
            if (editorFontSelect) {
                editorFontSelect.addEventListener('change', (e) => {
                    const activeObj = canvas.getActiveObject();
                    if (activeObj && activeObj.type === 'i-text') {
                        const fontName = e.target.value;
                        editorFontSelect.style.fontFamily = fontName;
                        
                        // Update custom trigger button display
                        const selectedFontNameEl = document.getElementById('selected-font-name');
                        if (selectedFontNameEl) {
                            selectedFontNameEl.textContent = fontName;
                            selectedFontNameEl.style.fontFamily = fontName;
                        }
                        // Update active class in custom list options
                        document.querySelectorAll('.font-option').forEach(opt => {
                            if (opt.dataset.font === fontName) {
                                opt.classList.add('active');
                            } else {
                                opt.classList.remove('active');
                            }
                        });
                        
                        if (!localFonts.includes(fontName)) {
                            loadGoogleFont(fontName);
                        }
                        
                        setTimeout(() => {
                            activeObj.set('fontFamily', fontName);
                            if (activeObj.customCurvature) {
                                applyTextCurvature(activeObj, activeObj.customCurvature);
                            }
                            canvas.renderAll();
                            debouncedSaveDesign();
                        }, 100);
                    }
                });
            }

            // Custom Font Dropdown Logic (for previewing fonts on mobile)
            const fontTrigger = document.getElementById('custom-font-select-trigger');
            const fontList = document.getElementById('custom-font-dropdown-list');
            
            if (fontTrigger && fontList) {
                fontTrigger.addEventListener('click', (e) => {
                    e.stopPropagation();
                    const isVisible = fontList.style.display === 'block';
                    fontList.style.display = isVisible ? 'none' : 'block';
                });
                
                document.querySelectorAll('.font-option').forEach(option => {
                    option.addEventListener('click', (e) => {
                        e.stopPropagation();
                        const fontName = option.dataset.font;
                        
                        if (editorFontSelect) {
                            editorFontSelect.value = fontName;
                            editorFontSelect.dispatchEvent(new Event('change'));
                        }
                        
                        fontList.style.display = 'none';
                    });
                });
                
                document.addEventListener('click', () => {
                    fontList.style.display = 'none';
                });
            }

            // Solid Fill / Outlined Etch style toggler
            btnTextOutline.addEventListener('click', () => {
                const activeObj = canvas.getActiveObject();
                if (activeObj) {
                    const currentStroke = activeObj.stroke;
                    if (currentStroke) {
                        activeObj.set({
                            fill: getEtchColor(),
                            stroke: null,
                            strokeWidth: 0
                        });
                    } else {
                        activeObj.set({
                            fill: 'transparent',
                            stroke: getEtchColor(),
                            strokeWidth: 1.5
                        });
                    }
                    canvas.renderAll();
                    debouncedSaveDesign();
                }
            });

            // Delete active layer
            btnDeleteLayer.addEventListener('click', () => {
                const activeObj = canvas.getActiveObject();
                if (activeObj) {
                    canvas.remove(activeObj);
                    canvas.discardActiveObject();
                    canvas.renderAll();
                    onObjectCleared();
                    showToast('Etch layer deleted.', 'fa-trash-can');
                }
            });

            if (liveBtnDeleteLayer) {
                liveBtnDeleteLayer.addEventListener('click', () => {
                    const activeObj = canvas.getActiveObject();
                    if (activeObj) {
                        canvas.remove(activeObj);
                        canvas.discardActiveObject();
                        canvas.renderAll();
                        onObjectCleared();
                        showToast('Etch layer deleted.', 'fa-trash-can');
                    }
                });
            }

            // Add New Text Box Button click handler
            btnAddText.addEventListener('click', () => {
                const textObj = new fabric.IText('NEW TEXT', {
                    left: 135,
                    top: 135,
                    fontSize: 20,
                    fontFamily: 'Outfit',
                    fontWeight: '700',
                    fill: getEtchColor(),
                    originX: 'center',
                    originY: 'center',
                    charSpacing: 100
                });
                canvas.add(textObj);
                canvas.setActiveObject(textObj);
                canvas.renderAll();
                updateLayerDropdown();
                showToast('New text layer added! Double-click to type.', 'fa-plus');
            });

            function checkAndRemoveDefaultTexts() {
                const defaultTexts = ['CUSTOM TEXT', 'SHRED IT!'];
                const objects = canvas.getObjects();
                objects.forEach(obj => {
                    if (obj.type === 'i-text' && defaultTexts.includes(obj.text)) {
                        canvas.remove(obj);
                    }
                });
                canvas.renderAll();
                updateLayerDropdown();
            }

            // Recursive function to apply etch style to loaded SVG elements (legacy fallback)
             function applyEtchStyle(obj, color) {
                 if (!obj) return;
                 if (obj.getObjects) {
                     obj.getObjects().forEach(child => applyEtchStyle(child, color));
                 } else {
                     const hasStroke = obj.stroke && obj.stroke !== 'none' && obj.stroke !== 'transparent';
                     const hasFill = obj.fill && obj.fill !== 'none' && obj.fill !== 'transparent';
                     
                     if (hasStroke) {
                         obj.set('stroke', color);
                     }
                     if (hasFill || (!hasStroke && !hasFill)) {
                         obj.set('fill', color);
                     }
                 }
             }

             // Recursive function to tag original fill/stroke values on loaded SVG paths
             function tagOriginalSvgPaths(obj) {
                 if (!obj) return;
                 if (obj.getObjects) {
                     obj.getObjects().forEach(child => tagOriginalSvgPaths(child));
                 } else {
                     if (obj.originalFill === undefined) {
                         obj.originalFill = obj.fill || null;
                     }
                     if (obj.originalStroke === undefined) {
                         obj.originalStroke = obj.stroke || null;
                     }
                     if (obj.originalStrokeWidth === undefined) {
                         obj.originalStrokeWidth = obj.strokeWidth || 0;
                     }
                 }
             }

             // Morphological contour filter to outline a raster canvas (for custom PNG/JPG decals)
             function createRasterOutlineCanvas(fillCanvas, thickness = 2) {
                 const lineCanvas = document.createElement('canvas');
                 lineCanvas.width = fillCanvas.width;
                 lineCanvas.height = fillCanvas.height;
                 const lineCtx = lineCanvas.getContext('2d');
                 
                 // Draw the image shifted in a circle of radius 'thickness'
                 for (let dx = -thickness; dx <= thickness; dx++) {
                     for (let dy = -thickness; dy <= thickness; dy++) {
                         if (dx === 0 && dy === 0) continue;
                         if (dx*dx + dy*dy > thickness*thickness) continue;
                         lineCtx.drawImage(fillCanvas, dx, dy);
                     }
                 }
                 
                 // Now subtract the original fillCanvas to leave only the outline
                 lineCtx.globalCompositeOperation = 'destination-out';
                 lineCtx.drawImage(fillCanvas, 0, 0);
                 lineCtx.globalCompositeOperation = 'source-over';
                 
                 return lineCanvas;
             }

             // Recolor all non-transparent pixels on a canvas
             function recolorCanvas(canvasEl, colorStr) {
                 if (!canvasEl) return;
                 const ctx = canvasEl.getContext('2d');
                 const imgData = ctx.getImageData(0, 0, canvasEl.width, canvasEl.height);
                 const data = imgData.data;
                 const r = parseInt(colorStr.slice(1, 3), 16);
                 const g = parseInt(colorStr.slice(3, 5), 16);
                 const b = parseInt(colorStr.slice(5, 7), 16);
                 for (let i = 0; i < data.length; i += 4) {
                     if (data[i + 3] > 0) { // If pixel is not transparent
                         data[i] = r;
                         data[i + 1] = g;
                         data[i + 2] = b;
                     }
                 }
                 ctx.putImageData(imgData, 0, 0);
             }

             // Apply specific etch mode (fill or line/outline) to a decal (vector or raster)
             function applyDecalEtchMode(obj, mode, color) {
                 if (!obj) return;
                 
                 // Track state on parent object
                 obj.decalEtchMode = mode;
                 
                 if (obj.decalType === 'raster' || obj.type === 'image') {
                     // Check if outline/fill canvas is initialized
                     if (!obj.fillCanvas || !obj.lineCanvas) {
                         const el = obj.getElement();
                         if (el) {
                             // Create a fill canvas and draw the image on it
                             const fillCanvas = document.createElement('canvas');
                             fillCanvas.width = el.width || el.naturalWidth;
                             fillCanvas.height = el.height || el.naturalHeight;
                             const fillCtx = fillCanvas.getContext('2d');
                             fillCtx.drawImage(el, 0, 0);
                             
                             obj.fillCanvas = fillCanvas;
                             obj.lineCanvas = createRasterOutlineCanvas(fillCanvas, 2);
                         }
                     }
                     
                     // Recolor both canvases to match active anodization color
                     recolorCanvas(obj.fillCanvas, color);
                     recolorCanvas(obj.lineCanvas, color);
                     
                     // Set active element on Fabric image
                     if (mode === 'line') {
                         obj.setElement(obj.lineCanvas);
                     } else {
                         obj.setElement(obj.fillCanvas);
                     }
                 } else {
                     // It's vector (group/path)
                     applyDecalEtchModeToVector(obj, mode, color);
                 }
             }

             // Helper to recursively walk vector path trees and toggle styling
             function applyDecalEtchModeToVector(obj, mode, color) {
                 if (!obj) return;
                 
                 // Tag original state first
                 tagOriginalSvgPaths(obj);
                 
                 if (obj.getObjects) {
                     obj.getObjects().forEach(child => applyDecalEtchModeToVector(child, mode, color));
                 } else {
                     const hasOriginalFill = obj.originalFill && obj.originalFill !== 'none' && obj.originalFill !== 'transparent';
                     const hasOriginalStroke = obj.originalStroke && obj.originalStroke !== 'none' && obj.originalStroke !== 'transparent';
                     
                     if (mode === 'line') {
                         if (hasOriginalFill || hasOriginalStroke || (!hasOriginalFill && !hasOriginalStroke)) {
                             obj.set({
                                 fill: 'transparent',
                                 stroke: color,
                                 strokeWidth: obj.originalStrokeWidth > 0 ? obj.originalStrokeWidth : 1.5
                             });
                         }
                     } else {
                         if (hasOriginalFill || (!hasOriginalFill && !hasOriginalStroke)) {
                             obj.set({
                                 fill: color,
                                 stroke: 'transparent',
                                 strokeWidth: 0
                             });
                         } else if (hasOriginalStroke) {
                             obj.set({
                                 fill: 'transparent',
                                 stroke: color,
                                 strokeWidth: obj.originalStrokeWidth || 1.5
                             });
                         }
                     }
                 }
             }

             // Toggle function for click handlers
             function toggleDecalEtchStyle(decalObj) {
                 if (!decalObj) return;
                 const newMode = (decalObj.decalEtchMode === 'line') ? 'fill' : 'line';
                 const etchColor = getEtchColor();
                 applyDecalEtchMode(decalObj, newMode, etchColor);
                 canvas.renderAll();
                 
                 // Sync outline button styling
                 const isOutline = (newMode === 'line');
                 const btnDecalOutline = document.getElementById('btn-decal-outline');
                 const mobileBtnDecalOutline = document.getElementById('mobile-btn-decal-outline');
                 if (btnDecalOutline) btnDecalOutline.classList.toggle('active', isOutline);
                 if (mobileBtnDecalOutline) mobileBtnDecalOutline.classList.toggle('active', isOutline);
                 
                 debouncedSaveDesign();
             }

            // Adding Predefined Decal Symbols
            decalButtons.forEach(btn => {
                btn.addEventListener('click', () => {
                    const presetKey = btn.dataset.presetDecal;
                    
                    // Sync active state across both desktop and mobile panels
                    decalButtons.forEach(b => {
                        if (b.dataset.presetDecal === presetKey) {
                            b.classList.add('active');
                        } else {
                            b.classList.remove('active');
                        }
                    });
                    
                    const fileName = DecalSVGFiles[presetKey];
                    if (!fileName) return;
                    
                    // Auto-delete unedited default texts
                    checkAndRemoveDefaultTexts();

                    let url = `Assets/Decals/${fileName}`;
                    if (window.CappedOutAssets && window.CappedOutAssets.decals && window.CappedOutAssets.decals[presetKey]) {
                        url = window.CappedOutAssets.decals[presetKey];
                    }
                    fetch(url)
                        .then(res => {
                            if (!res.ok) throw new Error('CORS or network error');
                            return res.text();
                        })
                        .then(svgText => {
                            fabric.loadSVGFromString(svgText, function(objects, options) {
                                const validObjects = objects.filter(obj => obj);
                                if (validObjects.length === 0) return;
                                
                                const decalObj = fabric.util.groupSVGElements(validObjects, options);
                                const isPremade = presetKey.startsWith('premade_');
                                const TARGET_SIZE = isPremade ? 150 : 95;
                                const rawW = decalObj.width || decalObj.getScaledWidth() || 1;
                                const rawH = decalObj.height || decalObj.getScaledHeight() || 1;
                                const baseScale = TARGET_SIZE / Math.max(rawW, rawH);

                                decalObj.set({
                                    left: 135,
                                    top: 135,
                                    originX: 'center',
                                    originY: 'center',
                                    scaleX: baseScale,
                                    scaleY: baseScale,
                                    baseScale: baseScale,
                                    hasControls: true,
                                    hasBorders: true,
                                    borderColor: '#ff0033',
                                    cornerColor: '#ff0033',
                                    cornerStrokeColor: '#07070a',
                                    cornerStyle: 'circle',
                                    cornerSize: 14,
                                    touchCornerSize: 32,
                                    transparentCorners: false,
                                    padding: 8
                                });
                                
                                const etchColor = getEtchColor();
                                decalObj.decalEtchMode = 'fill';
                                decalObj.decalType = 'vector';
                                applyDecalEtchMode(decalObj, 'fill', etchColor);
                                
                                canvas.add(decalObj);
                                canvas.setActiveObject(decalObj);
                                canvas.renderAll();
                                updateLayerDropdown();
                                debouncedSaveDesign();
                                
                                const displayName = fileName.replace('.svg', '');
                                showToast(`Added ${displayName} decal!`, 'fa-circle-check');
                            });
                        })
                        .catch(err => {
                            console.error('Error Vectorizing Decal SVG:', err);
                            showToast('Failed to load decal graphic.', 'fa-triangle-exclamation');
                        });
                });
            });

            // Image thresholding vectorizer tool for laser engraving preview
            function vectorizeAndFilterImage(imgElement, callback) {
                const tempCanvas = document.createElement('canvas');
                const ctx = tempCanvas.getContext('2d');
                
                // Keep dimensions clean for processing speed
                const maxDim = 300;
                let width = imgElement.width || imgElement.naturalWidth;
                let height = imgElement.height || imgElement.naturalHeight;
                if (width > maxDim || height > maxDim) {
                    if (width > height) {
                        height = Math.round((height * maxDim) / width);
                        width = maxDim;
                    } else {
                        width = Math.round((width * maxDim) / height);
                        height = maxDim;
                    }
                }
                
                tempCanvas.width = width;
                tempCanvas.height = height;
                ctx.drawImage(imgElement, 0, 0, width, height);
                
                // Get image pixel buffers
                const imgData = ctx.getImageData(0, 0, width, height);
                const data = imgData.data;
                // Process pixels: Threshold filter + recolor based on active cap anodization (always white as laser cannot produce black)
                for (let i = 0; i < data.length; i += 4) {
                    const r = data[i];
                    const g = data[i + 1];
                    const b = data[i + 2];
                    const a = data[i + 3];
                    
                    // Relative luminance calculation
                    const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
                    
                    // Simple binarization threshold (140)
                    // Lower values are more strict and reject light gray pixels as background.
                    if (a > 20 && luminance < 140) {
                        // Engraved marking colors: raw aluminum highlight (white) on all caps
                        data[i] = 255;
                        data[i + 1] = 255;
                        data[i + 2] = 255;
                        data[i + 3] = 240;
                    } else {
                        // Make light colors / background completely transparent
                        data[i + 3] = 0;
                    }
                }
                
                ctx.putImageData(imgData, 0, 0);
                
                // Load threshold processed data-url into Fabric.js
                const processedImg = new Image();
                processedImg.onload = function() {
                    const fImg = new fabric.Image(processedImg);
                    callback(fImg);
                };
                processedImg.src = tempCanvas.toDataURL();
            }

             // Unified handler for custom decal files (SVG or PNG/JPG)
             function handleDecalFile(file) {
                 if (!file) return;
                 
                 const isSvg = file.type === 'image/svg+xml' || file.name.toLowerCase().endsWith('.svg');
                 
                 if (isSvg) {
                     const reader = new FileReader();
                     reader.onload = function(event) {
                         const svgString = event.target.result;
                         fabric.loadSVGFromString(svgString, function(objects, options) {
                             const validObjects = objects.filter(obj => obj);
                             if (validObjects.length === 0) return;
                             
                             const decalObj = fabric.util.groupSVGElements(validObjects, options);
                             const TARGET_SIZE = 100;
                             const rawW = decalObj.width || decalObj.getScaledWidth() || 1;
                             const rawH = decalObj.height || decalObj.getScaledHeight() || 1;
                             const baseScale = TARGET_SIZE / Math.max(rawW, rawH);

                             decalObj.set({
                                 left: 135,
                                 top: 135,
                                 originX: 'center',
                                 originY: 'center',
                                 scaleX: baseScale,
                                 scaleY: baseScale,
                                 baseScale: baseScale,
                                 hasControls: true,
                                 hasBorders: true,
                                 borderColor: '#ff0033',
                                 cornerColor: '#ff0033',
                                 cornerStrokeColor: '#07070a',
                                 cornerStyle: 'circle',
                                 cornerSize: 14,
                                 touchCornerSize: 32,
                                 transparentCorners: false,
                                 padding: 8
                             });
                             
                             decalObj.decalEtchMode = 'fill';
                             decalObj.decalType = 'vector';
                             
                             const etchColor = getEtchColor();
                             applyDecalEtchMode(decalObj, 'fill', etchColor);
                             
                             checkAndRemoveDefaultTexts();
                             canvas.add(decalObj);
                             canvas.setActiveObject(decalObj);
                             canvas.renderAll();
                             updateLayerDropdown();
                             debouncedSaveDesign();
                             showToast('Custom SVG decal loaded!', 'fa-circle-check');
                         });
                     };
                     reader.readAsText(file);
                 } else {
                     // PNG/JPG
                     const reader = new FileReader();
                     reader.onload = function(event) {
                         const imgURL = event.target.result;
                         const loaderImg = new Image();
                         loaderImg.onload = function() {
                             vectorizeAndFilterImage(loaderImg, (filteredImg) => {
                                 checkAndRemoveDefaultTexts(); // Clear unedited text boxes
                                 filteredImg.scaleToWidth(100);
                                 const baseScale = filteredImg.scaleX || 1;
                                 filteredImg.set({
                                     left: 135,
                                     top: 135,
                                     originX: 'center',
                                     originY: 'center',
                                     baseScale: baseScale,
                                     hasControls: true,
                                     hasBorders: true,
                                     borderColor: '#ff0033',
                                     cornerColor: '#ff0033',
                                     cornerStrokeColor: '#07070a',
                                     cornerStyle: 'circle',
                                     cornerSize: 14,
                                     touchCornerSize: 32,
                                     transparentCorners: false,
                                     padding: 8
                                 });
                                 
                                 filteredImg.decalEtchMode = 'fill';
                                 filteredImg.decalType = 'raster';
                                 
                                 // Convert underlying image element to a canvas for pixel recoloring
                                 const el = filteredImg.getElement();
                                 const fillCanvas = document.createElement('canvas');
                                 fillCanvas.width = el.width || el.naturalWidth;
                                 fillCanvas.height = el.height || el.naturalHeight;
                                 const fillCtx = fillCanvas.getContext('2d');
                                 fillCtx.drawImage(el, 0, 0);
                                 
                                 filteredImg.fillCanvas = fillCanvas;
                                 filteredImg.lineCanvas = createRasterOutlineCanvas(fillCanvas, 2);
                                 
                                 // Explicitly tell Fabric to use the fill canvas
                                 filteredImg.setElement(fillCanvas);
                                 
                                 canvas.add(filteredImg);
                                 canvas.setActiveObject(filteredImg);
                                 canvas.renderAll();
                                 updateLayerDropdown();
                                 debouncedSaveDesign();
                                 showToast('Custom logo processed! Drag corners to resize.', 'fa-wand-magic-sparkles');
                             });
                         };
                         loaderImg.src = imgURL;
                     };
                     reader.readAsDataURL(file);
                 }
             }

             // File upload for custom decals / logos
             decalFileInput.addEventListener('change', (e) => {
                 const file = e.target.files[0];
                 handleDecalFile(file);
             });
 
             // Drag-and-drop uploads for decals
             decalDropzone.addEventListener('dragover', (e) => {
                 e.preventDefault();
                 decalDropzone.style.borderColor = '#ff0033';
             });
 
             decalDropzone.addEventListener('dragleave', () => {
                 decalDropzone.style.borderColor = 'rgba(255, 255, 255, 0.15)';
             });

             decalDropzone.addEventListener('drop', (e) => {
                 e.preventDefault();
                 decalDropzone.style.borderColor = 'rgba(255, 255, 255, 0.15)';
                 const file = e.dataTransfer.files[0];
                 handleDecalFile(file);
             });

             // === AI GENERATOR IMPLEMENTATION ===
             const btnGenerateAI = document.getElementById('btn-generate-ai');
             const aiPromptInput = document.getElementById('ai-prompt-input');
             const aiUsageCounter = document.getElementById('ai-usage-counter');
             
             const mobileBtnGenerateAI = document.getElementById('mobile-btn-generate-ai');
             const mobileAiPromptInput = document.getElementById('mobile-ai-prompt-input');
             const mobileAiUsageCounter = document.getElementById('mobile-ai-usage-counter');
             
             const MAX_AI_GENERATIONS = 3;

             function getAIGenerationCount() {
                 try {
                     return parseInt(sessionStorage.getItem('co_ai_generation_count') || '0', 10);
                 } catch (e) {
                     return 0;
                 }
             }

             function incrementAIGenerationCount() {
                 try {
                     const current = getAIGenerationCount();
                     sessionStorage.setItem('co_ai_generation_count', (current + 1).toString());
                     updateAIUsageUI();
                 } catch (e) {}
             }

             function updateAIUsageUI() {
                 const count = getAIGenerationCount();
                 
                 if (aiUsageCounter) {
                     aiUsageCounter.textContent = `${count} / ${MAX_AI_GENERATIONS} generations`;
                 }
                 if (btnGenerateAI) {
                     if (count >= MAX_AI_GENERATIONS) {
                         btnGenerateAI.disabled = true;
                         btnGenerateAI.innerHTML = '<i class="fa-solid fa-lock"></i> Session Limit Reached';
                         btnGenerateAI.style.background = '#333';
                         btnGenerateAI.style.borderColor = '#444';
                         btnGenerateAI.style.color = '#777';
                     }
                 }

                 if (mobileAiUsageCounter) {
                     mobileAiUsageCounter.textContent = `${count} / ${MAX_AI_GENERATIONS}`;
                 }
                 if (mobileBtnGenerateAI) {
                     if (count >= MAX_AI_GENERATIONS) {
                         mobileBtnGenerateAI.disabled = true;
                         mobileBtnGenerateAI.innerHTML = '<i class="fa-solid fa-lock"></i> Locked';
                         mobileBtnGenerateAI.style.background = '#333';
                         mobileBtnGenerateAI.style.borderColor = '#444';
                         mobileBtnGenerateAI.style.color = '#777';
                     }
                 }
             }

             // Initial counter sync on page load
             updateAIUsageUI();

             async function runAIGeneration(promptText, triggerBtn, sourceInput) {
                 const count = getAIGenerationCount();
                 if (count >= MAX_AI_GENERATIONS) {
                     showToast('Generation limit reached for this session!', 'fa-lock');
                     return;
                 }

                 const prompt = promptText.trim();
                 if (!prompt) {
                     showToast('Please type a prompt first!', 'fa-triangle-exclamation');
                     if (sourceInput) sourceInput.focus();
                     return;
                 }

                 if (btnGenerateAI) btnGenerateAI.disabled = true;
                 if (mobileBtnGenerateAI) mobileBtnGenerateAI.disabled = true;
                 
                 const originalHtml = triggerBtn.innerHTML;
                 triggerBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Generating Stencil...';
                 showToast('Creating laser stencil from prompt...', 'fa-wand-magic-sparkles');

                 const seed = Math.floor(Math.random() * 1000000);
                 const rawPrompt = `${prompt}, binary black and white, solid vector stencil, clean black outline silhouette on pure white background, laser engraving template style, no gradients, no shading, no gray, flat design icon`;
                 const directUrl = `https://image.pollinations.ai/prompt/${encodeURIComponent(rawPrompt)}?width=512&height=512&seed=${seed}&nologo=true&model=flux`;

                 const restoreButtons = () => {
                     const c = getAIGenerationCount();
                     if (btnGenerateAI && c < MAX_AI_GENERATIONS) btnGenerateAI.disabled = false;
                     if (mobileBtnGenerateAI && c < MAX_AI_GENERATIONS) mobileBtnGenerateAI.disabled = false;
                     if (c < MAX_AI_GENERATIONS) triggerBtn.innerHTML = originalHtml;
                 };

                 try {
                     let response = await fetch(directUrl, { mode: 'cors' });
                     if (response.status === 402 || response.status === 429) {
                         triggerBtn.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Server busy, retrying...';
                         await new Promise(r => setTimeout(r, 4000));
                         response = await fetch(directUrl + '&retry=1', { mode: 'cors' });
                     }

                     if (!response.ok) {
                         throw new Error(`HTTP ${response.status}`);
                     }

                     const contentType = response.headers.get('content-type') || '';
                     if (!contentType.includes('image')) {
                         throw new Error('Non-image response');
                     }

                     const blob = await response.blob();
                     const objectUrl = URL.createObjectURL(blob);

                     const loaderImg = new Image();
                     loaderImg.crossOrigin = 'anonymous';
                     loaderImg.onload = function() {
                         URL.revokeObjectURL(objectUrl);
                         vectorizeAndFilterImage(loaderImg, (filteredImg) => {
                             checkAndRemoveDefaultTexts();
                             filteredImg.scaleToWidth(115);
                             const baseScale = filteredImg.scaleX || 1;
                             filteredImg.set({
                                 left: 135,
                                 top: 135,
                                 originX: 'center',
                                 originY: 'center',
                                 baseScale: baseScale,
                                 hasControls: true,
                                 hasBorders: true,
                                 borderColor: '#ff0033',
                                 cornerColor: '#ff0033',
                                 cornerStrokeColor: '#07070a',
                                 cornerStyle: 'circle',
                                 cornerSize: 14,
                                 touchCornerSize: 32,
                                 transparentCorners: false,
                                 padding: 8
                             });

                             filteredImg.decalEtchMode = 'fill';
                             filteredImg.decalType = 'raster';

                             const el = filteredImg.getElement();
                             const fillCanvas = document.createElement('canvas');
                             fillCanvas.width = el.width || el.naturalWidth;
                             fillCanvas.height = el.height || el.naturalHeight;
                             const fillCtx = fillCanvas.getContext('2d');
                             fillCtx.drawImage(el, 0, 0);

                             filteredImg.fillCanvas = fillCanvas;
                             filteredImg.lineCanvas = createRasterOutlineCanvas(fillCanvas, 2);

                             filteredImg.setElement(fillCanvas);

                             canvas.add(filteredImg);
                             canvas.setActiveObject(filteredImg);
                             canvas.renderAll();
                             updateLayerDropdown();
                             debouncedSaveDesign();

                             incrementAIGenerationCount();
                             restoreButtons();
                             
                             if (aiPromptInput) aiPromptInput.value = '';
                             if (mobileAiPromptInput) mobileAiPromptInput.value = '';

                             showToast('AI graphic generated and loaded!', 'fa-circle-check');
                         });
                     };
                     loaderImg.onerror = function() {
                         URL.revokeObjectURL(objectUrl);
                         showToast('AI image load failed. Please try again in a few seconds.', 'fa-triangle-exclamation');
                         restoreButtons();
                     };
                     loaderImg.src = objectUrl;
                 } catch (err) {
                     console.warn('AI generation error:', err);
                     showToast('Free AI server is busy (1 image / 45s limit). Wait a moment or use Decals / Upload!', 'fa-clock');
                     restoreButtons();
                 }
             }

             if (btnGenerateAI) {
                 btnGenerateAI.addEventListener('click', () => {
                     const prompt = aiPromptInput ? aiPromptInput.value : '';
                     runAIGeneration(prompt, btnGenerateAI, aiPromptInput);
                 });
             }

             if (mobileBtnGenerateAI) {
                 mobileBtnGenerateAI.addEventListener('click', () => {
                     const prompt = mobileAiPromptInput ? mobileAiPromptInput.value : '';
                     runAIGeneration(prompt, mobileBtnGenerateAI, mobileAiPromptInput);
                 });
             }

             // Listen to decal size slider changes (relative to baseScale so 100% is normalized default size)
             const decalSizeSlider = document.getElementById('decal-size-slider');
             const decalSizeDisplay = document.getElementById('decal-size-display');
             if (decalSizeSlider) {
                 decalSizeSlider.addEventListener('input', (e) => {
                     const activeObj = canvas.getActiveObject();
                     if (activeObj && activeObj.type !== 'i-text') {
                         if (!activeObj.baseScale) {
                             activeObj.baseScale = Math.abs(activeObj.scaleX) || 1;
                         }
                         const pct = parseInt(e.target.value, 10);
                         const targetScale = activeObj.baseScale * (pct / 100);
                         activeObj.set({
                             scaleX: targetScale,
                             scaleY: targetScale
                         });
                         activeObj.setCoords();
                         canvas.renderAll();
                         if (decalSizeDisplay) {
                             decalSizeDisplay.textContent = `${pct}%`;
                         }
                         debouncedSaveDesign();
                     }
                 });
             }

             // Listen to decal rotation slider changes
             const decalRotateSlider = document.getElementById('decal-rotate-slider');
             const decalRotateDisplay = document.getElementById('decal-rotate-display');
             if (decalRotateSlider) {
                 decalRotateSlider.addEventListener('input', (e) => {
                     const activeObj = canvas.getActiveObject();
                     if (activeObj && activeObj.type !== 'i-text') {
                         const rotVal = parseInt(e.target.value, 10);
                         activeObj.set('angle', rotVal);
                         activeObj.setCoords();
                         canvas.renderAll();
                         if (decalRotateDisplay) {
                             decalRotateDisplay.textContent = `${rotVal}°`;
                         }
                         debouncedSaveDesign();
                     }
                 });
             }

             // Sync sliders and normalize text fontSize when scaling object manually using corner handles
             if (canvas) {
                 canvas.on('object:scaling', (e) => {
                     const activeObj = e.target;
                     if (!activeObj) return;
                     if (activeObj.type === 'i-text') {
                         const scaleFactor = activeObj.scaleX || 1;
                         const newFontSize = Math.max(8, Math.min(64, Math.round((activeObj.fontSize || 22) * scaleFactor)));
                         activeObj.set({
                             fontSize: newFontSize,
                             scaleX: 1,
                             scaleY: 1
                         });
                         if (activeObj.customCurvature) {
                             applyTextCurvature(activeObj, activeObj.customCurvature);
                         }
                         if (editorTextSize) editorTextSize.value = newFontSize;
                         if (liveEditorTextSize) liveEditorTextSize.value = newFontSize;
                         if (liveSizeValueDisplay) liveSizeValueDisplay.textContent = `${newFontSize}px`;
                     } else {
                         if (!activeObj.baseScale) {
                             activeObj.baseScale = Math.abs(activeObj.scaleX) || 1;
                         }
                         const scalePercent = Math.round((Math.abs(activeObj.scaleX || 1.0) / activeObj.baseScale) * 100);
                         if (decalSizeSlider) {
                             decalSizeSlider.value = Math.max(20, Math.min(250, scalePercent));
                         }
                         if (decalSizeDisplay) {
                             decalSizeDisplay.textContent = `${scalePercent}%`;
                         }
                     }
                 });
             }

             // Decal Outline / Solid Fill toggler
             const btnDecalOutline = document.getElementById('btn-decal-outline');
             if (btnDecalOutline) {
                 btnDecalOutline.addEventListener('click', () => {
                     const activeObj = canvas.getActiveObject();
                     if (activeObj && activeObj.type !== 'i-text') {
                         toggleDecalEtchStyle(activeObj);
                     }
                 });
             }
 
             const mobileBtnDecalOutline = document.getElementById('mobile-btn-decal-outline');
             if (mobileBtnDecalOutline) {
                 mobileBtnDecalOutline.addEventListener('click', () => {
                     const activeObj = canvas.getActiveObject();
                     if (activeObj && activeObj.type !== 'i-text') {
                         toggleDecalEtchStyle(activeObj);
                     }
                 });
             }
 
             // Decal Delete layer
             const btnDeleteDecalLayer = document.getElementById('btn-delete-decal-layer');
             if (btnDeleteDecalLayer) {
                 btnDeleteDecalLayer.addEventListener('click', () => {
                     const activeObj = canvas.getActiveObject();
                     if (activeObj) {
                         canvas.remove(activeObj);
                         canvas.discardActiveObject();
                         canvas.renderAll();
                         onObjectCleared();
                         debouncedSaveDesign();
                         showToast('Graphic layer deleted.', 'fa-trash-can');
                     }
                 });
             }

             // Debounce, saveCurrentDesign, and debouncedSaveDesign have been moved to the top of canvas setup for reliability

             // Restore design customizer configuration and canvas from localStorage
             function loadSavedDesign() {
                 if (!canvas) return;
                 
                 const savedDataStr = sessionStorage.getItem('cappedout_saved_design');
                 if (!savedDataStr) return;
                 
                 try {
                     const savedData = JSON.parse(savedDataStr);
                     if (!savedData) return;
                     
                     // 1. Restore state customizer choices
                     if (savedData.state) {
                         state.customizer.color = savedData.state.color || 'black';
                         state.customizer.colorName = savedData.state.colorName || 'Black';
                         state.customizer.bolt = savedData.state.bolt || 'none';
                         state.customizer.boltName = savedData.state.boltName || 'No Bolt (Cap Only)';
                         state.customizer.boltPrice = savedData.state.boltPrice || 0;
                         state.customizer.packaging = savedData.state.packaging || false;
                         
                         // Sync UI active states for colors and bolts
                         const colorBtn = document.querySelector(`.color-option-btn[data-color="${state.customizer.color}"]`);
                         if (colorBtn) {
                             colorButtons.forEach(btn => btn.classList.remove('active'));
                             colorBtn.classList.add('active');
                         }
                         const boltCard = document.querySelector(`.bolt-option-card[data-bolt="${state.customizer.bolt}"]`);
                         if (boltCard) {
                             boltCards.forEach(card => card.classList.remove('active'));
                             boltCard.classList.add('active');
                         }
                         if (packagingCheckbox) {
                             packagingCheckbox.checked = state.customizer.packaging;
                             if (state.customizer.packaging) {
                                 packagingCard.classList.add('active');
                             } else {
                                 packagingCard.classList.remove('active');
                             }
                         }
                     }
                     
                     // 2. Restore canvas elements
                     if (savedData.canvas) {
                         // Clear current objects
                         canvas.clear();
                         
                         // Re-establish clipPath
                         canvas.clipPath = new fabric.Circle({
                             radius: 135,
                             left: 135,
                             top: 135,
                             originX: 'center',
                             originY: 'center',
                             absolutePositioned: true
                         });
                         
                         canvas.loadFromJSON(savedData.canvas, function() {
                             // After JSON loading, make sure all layers are interactive and custom parameters are handled
                             canvas.getObjects().forEach(obj => {
                                 if (obj.type === 'i-text') {
                                     if (obj.customCurvature === undefined) {
                                         obj.customCurvature = 0;
                                     }
                                 } else {
                                     // It's a decal. Tag paths, make sure decal properties are initialized
                                     tagOriginalSvgPaths(obj);
                                     
                                     // If it is raster (image), ensure its fillCanvas and lineCanvas are re-generated
                                     if (obj.decalType === 'raster' || obj.type === 'image') {
                                         const el = obj.getElement();
                                         if (el) {
                                             const fillCanvas = document.createElement('canvas');
                                             fillCanvas.width = el.width || el.naturalWidth;
                                             fillCanvas.height = el.height || el.naturalHeight;
                                             const fillCtx = fillCanvas.getContext('2d');
                                             fillCtx.drawImage(el, 0, 0);
                                             
                                             obj.fillCanvas = fillCanvas;
                                             obj.lineCanvas = createRasterOutlineCanvas(fillCanvas, 2);
                                             
                                             // Make sure active mode is shown correctly
                                             if (obj.decalEtchMode === 'line') {
                                                 obj.setElement(obj.lineCanvas);
                                             } else {
                                                 obj.setElement(obj.fillCanvas);
                                             }
                                         }
                                     }
                                 }
                             });
                             
                             canvas.renderAll();
                             updateLayerDropdown();
                             renderCustomizer(); // Redraw static finishes and bolt
                             showToast('Loaded your saved design!', 'fa-cloud-arrow-down');
                         });
                     }
                 } catch (e) {
                     console.error("Failed to restore saved design from localStorage:", e);
                 }
             }
 
             const mobileBtnDeleteDecal = document.getElementById('mobile-btn-delete-decal');
             if (mobileBtnDeleteDecal) {
                 mobileBtnDeleteDecal.addEventListener('click', () => {
                     const activeObj = canvas.getActiveObject();
                     if (activeObj) {
                         canvas.remove(activeObj);
                         canvas.discardActiveObject();
                         canvas.renderAll();
                         onObjectCleared();
                         showToast('Graphic layer deleted.', 'fa-trash-can');
                     }
                 });
             }

             // Flip Horizontal (desktop)
             const btnFlipX = document.getElementById('btn-flip-x');
             if (btnFlipX) {
                 btnFlipX.addEventListener('click', () => {
                     const activeObj = canvas.getActiveObject();
                     if (activeObj) {
                         activeObj.set('flipX', !activeObj.flipX);
                         canvas.renderAll();
                         debouncedSaveDesign();
                         showToast('Flipped horizontally.', 'fa-left-right');
                     }
                 });
             }

             // Flip Vertical (desktop)
             const btnFlipY = document.getElementById('btn-flip-y');
             if (btnFlipY) {
                 btnFlipY.addEventListener('click', () => {
                     const activeObj = canvas.getActiveObject();
                     if (activeObj) {
                         activeObj.set('flipY', !activeObj.flipY);
                         canvas.renderAll();
                         debouncedSaveDesign();
                         showToast('Flipped vertically.', 'fa-up-down');
                     }
                 });
             }

             // Flip Horizontal (mobile)
             const mobileBtnFlipX = document.getElementById('mobile-btn-flip-x');
             if (mobileBtnFlipX) {
                 mobileBtnFlipX.addEventListener('click', () => {
                     const activeObj = canvas.getActiveObject();
                     if (activeObj) {
                         activeObj.set('flipX', !activeObj.flipX);
                         canvas.renderAll();
                         debouncedSaveDesign();
                         showToast('Flipped horizontally.', 'fa-left-right');
                     }
                 });
             }

             // Flip Vertical (mobile)
             const mobileBtnFlipY = document.getElementById('mobile-btn-flip-y');
             if (mobileBtnFlipY) {
                 mobileBtnFlipY.addEventListener('click', () => {
                     const activeObj = canvas.getActiveObject();
                     if (activeObj) {
                         activeObj.set('flipY', !activeObj.flipY);
                         canvas.renderAll();
                         debouncedSaveDesign();
                         showToast('Flipped vertically.', 'fa-up-down');
                     }
                 });
             }

             // Load any previously saved design from localStorage
             loadSavedDesign();

             // ── Position Nudge Handlers (D-Pad) ──
             document.querySelectorAll('.btn-nudge-dir').forEach(btn => {
                 btn.addEventListener('click', (e) => {
                     e.preventDefault();
                     const activeObj = canvas.getActiveObject();
                     if (!activeObj) return;
                     const dx = parseFloat(btn.dataset.nudgeX || 0);
                     const dy = parseFloat(btn.dataset.nudgeY || 0);
                     activeObj.set({
                         left: (activeObj.left || 0) + dx,
                         top: (activeObj.top || 0) + dy
                     });
                     if (activeObj.type === 'i-text' && activeObj._flatCenter) {
                         activeObj._flatCenter.x += dx;
                         activeObj._flatCenter.y += dy;
                     }
                     activeObj.setCoords();
                     canvas.renderAll();
                     debouncedSaveDesign();
                 });
             });

             document.querySelectorAll('.btn-nudge-center').forEach(btn => {
                 btn.addEventListener('click', (e) => {
                     e.preventDefault();
                     const activeObj = canvas.getActiveObject();
                     if (!activeObj) return;
                     activeObj.center();
                     if (activeObj.type === 'i-text') {
                         activeObj._flatCenter = activeObj.getCenterPoint();
                     }
                     activeObj.setCoords();
                     canvas.renderAll();
                     debouncedSaveDesign();
                     showToast('Centered on cap', 'fa-arrows-to-dot');
                 });
             });

             // ── SVG Preview Injection ──────────────────────────────────
             // Replace Font Awesome placeholder icons in decal selector
             // buttons with the actual SVG/raster preview of each decal.
             (function injectDecalPreviews() {
                 document.querySelectorAll('.graphic-option-btn[data-preset-decal]').forEach(function(btn) {
                     var key = btn.dataset.presetDecal;
                     var fileName = DecalSVGFiles[key];
                     if (!fileName) return;

                     // Build URL via Shopify CDN (CappedOutAssets) or fallback
                     var url;
                     if (window.CappedOutAssets && window.CappedOutAssets.decals && window.CappedOutAssets.decals[key]) {
                         url = window.CappedOutAssets.decals[key];
                     } else {
                         url = 'Assets/' + fileName;
                     }

                     // Remove existing <i> icon
                     var iconEl = btn.querySelector('i');
                     if (iconEl) iconEl.remove();

                     // Insert preview image before the label span
                     var img = document.createElement('img');
                     img.src = url;
                     img.alt = '';
                     img.className = 'decal-preview-img';
                     img.draggable = false;
                     // For raster (jpg/jpeg/png) images, don't invert colours
                     if (fileName.match(/\.(jpg|jpeg|png)$/i)) {
                         img.style.filter = 'none';
                         img.style.borderRadius = '6px';
                     }
                     var spanEl = btn.querySelector('span');
                     btn.insertBefore(img, spanEl || null);
                 });
             })();

             // ── Global Always-Visible Delete Button ───────────────────
             var btnGlobalDelete = document.getElementById('btn-global-delete');
             if (btnGlobalDelete) {
                 btnGlobalDelete.addEventListener('click', function() {
                     var activeObj = canvas.getActiveObject();
                     if (activeObj) {
                         canvas.remove(activeObj);
                         canvas.discardActiveObject();
                         canvas.renderAll();
                         onObjectCleared();
                         debouncedSaveDesign();
                         showToast('Layer deleted.', 'fa-trash-can');
                     }
                 });
             }

             // Show/hide the global delete button based on canvas selection
             function updateGlobalDeleteVisibility() {
                 if (!btnGlobalDelete) return;
                 if (canvas.getActiveObject()) {
                     btnGlobalDelete.classList.add('visible');
                 } else {
                     btnGlobalDelete.classList.remove('visible');
                 }
             }

             canvas.on('selection:created', updateGlobalDeleteVisibility);
             canvas.on('selection:updated', updateGlobalDeleteVisibility);
             canvas.on('selection:cleared', updateGlobalDeleteVisibility);

         } else {
            console.warn("Fabric.js is undefined. Fallback logic initialized.");
        }
    } catch (err) {
        console.error("Error setting up Fabric canvas:", err);
    }

    // === WIZARD RENDER CAP & PRICES ===
    function renderCustomizer() {
        if (!capBase) return;
        const config = state.customizer;
        
        // Update static underlay cap color
        capBase.setAttribute('fill', SVGGradients[config.color] || SVGGradients.black);
        
        // Dynamically update etch color of existing Fabric objects on the canvas
        if (canvas) {
            const etchColor = '#ffffff';
            
            canvas.getObjects().forEach(obj => {
                if (obj.type === 'i-text') {
                    if (obj.stroke) {
                        obj.set('stroke', etchColor);
                    } else {
                        obj.set('fill', etchColor);
                    }
                } else {
                    const mode = obj.decalEtchMode || 'fill';
                    applyDecalEtchMode(obj, mode, etchColor);
                }
            });
            canvas.renderAll();
        }
           // Update overlay bolt head and hide if "No Bolt" is selected
        const boltGroup = document.getElementById('custom-bolt-group');
        if (boltGroup) {
            if (config.bolt === 'none') {
                boltGroup.style.display = 'none';
            } else {
                boltGroup.style.display = 'inline';
                if (boltHead) {
                    boltHead.setAttribute('fill', SVGBolts[config.bolt] || 'url(#bolt-black)');
                }
            }
        }
 
        // Summary step bindings
        if (sumFinish) sumFinish.textContent = config.colorName;
        if (sumBolt) sumBolt.textContent = config.boltName;
        if (sumPackaging) sumPackaging.textContent = config.packaging ? 'Yes (+ $10.00 AUD)' : 'No (Standard Envelope)';

        // Dynamically sync Step 4 text & graphic summary rows from live canvas objects
        const sumTopText = document.getElementById('sum-top-text');
        const sumBottomText = document.getElementById('sum-bottom-text');
        const sumGraphic = document.getElementById('sum-graphic');
        const sumDesignService = document.getElementById('sum-design-service');
        const designServicePriceRow = document.getElementById('design-service-price-row');

        if (canvas) {
            const objs = canvas.getObjects().filter(o => !o.isGuide && o.id !== 'curvature-guide' && o.id !== 'snap-guide-x' && o.id !== 'snap-guide-y');
            const textObjs = objs.filter(o => o.type === 'i-text');
            const graphicObjs = objs.filter(o => o.type !== 'i-text');

            if (sumTopText) {
                sumTopText.textContent = textObjs[0] ? `"${textObjs[0].text}" (${textObjs[0].fontFamily})` : 'None';
            }
            if (sumBottomText) {
                if (textObjs.length > 2) {
                    sumBottomText.textContent = textObjs.slice(1).map(t => `"${t.text}"`).join(', ');
                } else {
                    sumBottomText.textContent = textObjs[1] ? `"${textObjs[1].text}" (${textObjs[1].fontFamily})` : 'None';
                }
            }
            if (sumGraphic) {
                sumGraphic.textContent = graphicObjs.length > 0 ? `${graphicObjs.length} Graphic Layer(s)` : 'None (Text Only)';
            }
        }
        if (sumDesignService) {
            sumDesignService.textContent = config.designService ? 'Yes (+$10.00 AUD)' : 'No (Self-Designed)';
        }
        if (designServicePriceRow) {
            designServicePriceRow.style.display = config.designService ? 'flex' : 'none';
        }
        
        if (boltPriceRow) {
            if (config.boltPrice > 0) {
                boltPriceRow.style.display = 'flex';
                if (sumBoltPrice) sumBoltPrice.textContent = `+$${config.boltPrice.toFixed(2)} AUD`;
            } else {
                boltPriceRow.style.display = 'none';
            }
        }
        
        if (packagingPriceRow) {
            if (config.packaging) {
                packagingPriceRow.style.display = 'flex';
            } else {
                packagingPriceRow.style.display = 'none';
            }
        }
        
        const finalPrice = getCustomizerTotalPrice();
        if (totalAmountSpan) totalAmountSpan.textContent = `$${finalPrice.toFixed(2)} AUD`;
        const mobileBarPrice = document.getElementById('mobile-customizer-bar-price');
        if (mobileBarPrice) mobileBarPrice.textContent = `$${finalPrice.toFixed(2)} AUD`;
        
        // Auto-save design state changes
        if (typeof debouncedSaveDesign === 'function') {
            debouncedSaveDesign();
        }
    }

    // === NAVIGATION AND WIZARD FLOW ===
    function goToStep(stepNum) {
        if (!prevBtn || !nextBtn) return;
        state.customizer.step = stepNum;
        
        stepButtons.forEach(btn => {
            btn.classList.remove('active');
            if (parseInt(btn.dataset.step) === stepNum) {
                btn.classList.add('active');
            }
        });
        
        panes.forEach(pane => {
            pane.classList.remove('active');
            if (parseInt(pane.dataset.pane) === stepNum) {
                pane.classList.add('active');
            }
        });
        
        prevBtn.disabled = stepNum === 1;
        
        if (stepNum === 4) {
            renderCustomizer();
            nextBtn.style.display = 'none';
            if (addToCartBtn) addToCartBtn.style.display = 'flex';
        } else {
            nextBtn.style.display = 'inline-flex';
            nextBtn.innerHTML = 'Next Step <i class="fa-solid fa-arrow-right"></i>';
            if (addToCartBtn) addToCartBtn.style.display = 'none';
        }

        // Sync Mobile Customizer Action Bar
        const mobileBarPrice = document.getElementById('mobile-customizer-bar-price');
        const mobileBarBtn = document.getElementById('mobile-bar-action-btn');
        if (mobileBarBtn) {
            if (stepNum === 4) {
                mobileBarBtn.innerHTML = '<span>Add to Cart</span> <i class="fa-solid fa-cart-plus"></i>';
            } else {
                mobileBarBtn.innerHTML = '<span>Next Step</span> <i class="fa-solid fa-arrow-right"></i>';
            }
        }

        // Only keep the preview sticky when actively designing on Step 2 (or if a layer is selected on Step 2)
        if (stepNum === 2 && canvas) {
            if (!canvas.getActiveObject()) {
                const editableObjs = canvas.getObjects().filter(o => !o.isGuide && o.id !== 'curvature-guide' && o.id !== 'snap-guide-x' && o.id !== 'snap-guide-y');
                if (editableObjs.length > 0) {
                    canvas.setActiveObject(editableObjs[0]);
                    canvas.renderAll();
                }
            }
        } else if (stepNum !== 2 && canvas) {
            canvas.discardActiveObject();
            canvas.renderAll();
        }
        if (typeof window.syncActiveDesigningStickyState === 'function') {
            window.syncActiveDesigningStickyState(stepNum === 2);
        }
    }

    // Expose goToStep globally so preset/customize buttons outside this closure can navigate wizard steps
    window.goToStep = goToStep;

    if (nextBtn) {
        nextBtn.addEventListener('click', () => {
            if (state.customizer.step < 4) goToStep(state.customizer.step + 1);
        });
    }

    if (prevBtn) {
        prevBtn.addEventListener('click', () => {
            if (state.customizer.step > 1) goToStep(state.customizer.step - 1);
        });
    }

        stepButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            goToStep(parseInt(btn.dataset.step));
        });
    });

    // Wire up Mobile Action Bar Button
    const mobileBarBtn = document.getElementById('mobile-bar-action-btn');
    if (mobileBarBtn) {
        mobileBarBtn.addEventListener('click', () => {
            if (state.customizer.step < 4) {
                goToStep(state.customizer.step + 1);
            } else {
                if (addToCartBtn) addToCartBtn.click();
            }
        });
    }

    // Step 1 Finish Selection
    colorButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            const selectedColor = btn.dataset.color;
            colorButtons.forEach(b => {
                if (b.dataset.color === selectedColor) {
                    b.classList.add('active');
                } else {
                    b.classList.remove('active');
                }
            });
            state.customizer.color = btn.dataset.color;
            state.customizer.colorName = btn.dataset.colorName;
            renderCustomizer();
        });
    });

    // Step 2 internal layout tabs
    tabButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            tabButtons.forEach(b => b.classList.remove('active'));
            tabPanes.forEach(p => p.classList.remove('active'));
            btn.classList.add('active');
            const targetEl = document.getElementById(btn.dataset.tab);
            if (targetEl) targetEl.classList.add('active');
        });
    });

    // Step 3 Bolts
    boltCards.forEach(card => {
        card.addEventListener('click', () => {
            const selectedBolt = card.dataset.bolt;
            boltCards.forEach(c => {
                if (c.dataset.bolt === selectedBolt) {
                    c.classList.add('active');
                } else {
                    c.classList.remove('active');
                }
            });
            state.customizer.bolt = card.dataset.bolt;
            state.customizer.boltPrice = parseFloat(card.dataset.boltPrice);
            state.customizer.boltName = card.dataset.boltName;
            renderCustomizer();
        });
    });

    if (packagingCard && packagingCheckbox) {
        packagingCard.addEventListener('click', (e) => {
            if (e.target.tagName !== 'INPUT') {
                packagingCheckbox.checked = !packagingCheckbox.checked;
            }
            state.customizer.packaging = packagingCheckbox.checked;
            if (state.customizer.packaging) {
                packagingCard.classList.add('active');
            } else {
                packagingCard.classList.remove('active');
            }
            renderCustomizer();
        });
    }

    // Step 2: Expert Design Service ("Design For You") Toggle & Inputs
    const designServiceCard = document.getElementById('design-service-toggle-card');
    const serviceCheckboxIndicator = document.getElementById('service-checkbox-indicator');
    const designServiceFields = document.getElementById('design-service-fields');
    const serviceInstructionsInput = document.getElementById('service-instructions');
    const serviceReferenceFile = document.getElementById('service-reference-file');
    const serviceUploadPromptText = document.getElementById('service-upload-prompt-text');
    const serviceFilePreview = document.getElementById('service-file-preview');
    const serviceFileNameSpan = document.getElementById('service-file-name');
    const btnRemoveServiceFile = document.getElementById('btn-remove-service-file');

    if (designServiceCard) {
        designServiceCard.addEventListener('click', () => {
            state.customizer.designService = !state.customizer.designService;
            const isChecked = state.customizer.designService;
            designServiceCard.style.borderColor = isChecked ? 'var(--accent)' : 'var(--border-color)';
            designServiceCard.style.background = isChecked ? 'rgba(255, 0, 51, 0.06)' : 'rgba(255,255,255,0.02)';
            if (serviceCheckboxIndicator) {
                const checkIcon = serviceCheckboxIndicator.querySelector('i');
                if (checkIcon) checkIcon.style.display = isChecked ? 'block' : 'none';
                serviceCheckboxIndicator.style.borderColor = isChecked ? 'var(--accent)' : 'var(--border-color)';
            }
            if (designServiceFields) {
                designServiceFields.style.display = isChecked ? 'block' : 'none';
            }
            renderCustomizer();
            showToast(isChecked ? 'Expert Design Service (+$10) added!' : 'Expert Design Service removed.', 'fa-wand-magic');
        });
    }

    if (serviceInstructionsInput) {
        serviceInstructionsInput.addEventListener('input', (e) => {
            state.customizer.serviceInstructions = e.target.value;
        });
    }

    if (serviceReferenceFile) {
        serviceReferenceFile.addEventListener('change', (e) => {
            const file = e.target.files[0];
            if (!file) return;
            state.customizer.serviceFileName = file.name;
            if (serviceUploadPromptText) serviceUploadPromptText.style.display = 'none';
            if (serviceFilePreview) serviceFilePreview.style.display = 'flex';
            if (serviceFileNameSpan) serviceFileNameSpan.textContent = file.name;
            // Also load onto canvas so it gets uploaded with the design preview!
            if (typeof handleDecalFile === 'function') {
                handleDecalFile(file);
            }
        });
    }

    if (btnRemoveServiceFile) {
        btnRemoveServiceFile.addEventListener('click', (e) => {
            e.stopPropagation();
            if (serviceReferenceFile) serviceReferenceFile.value = '';
            state.customizer.serviceFileName = '';
            if (serviceUploadPromptText) serviceUploadPromptText.style.display = 'block';
            if (serviceFilePreview) serviceFilePreview.style.display = 'none';
        });
    }

    // === CART & DRAWER LOGIC ===
    function openCart() {
        if (cartDrawer && cartOverlay) {
            cartDrawer.classList.add('active');
            cartOverlay.classList.add('active');
        }
    }

    function closeCart() {
        if (cartDrawer && cartOverlay) {
            cartDrawer.classList.remove('active');
            cartOverlay.classList.remove('active');
        }
    }

    if (cartBtn) cartBtn.addEventListener('click', openCart);
    if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
    if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

    function refreshCartUI() {
        if (!cartItemsContainer) return;
        const count = state.cart.reduce((acc, curr) => acc + curr.qty, 0);
        cartCountBadges.forEach(badge => { badge.textContent = count; });
        if (cartTotalQty) cartTotalQty.textContent = count;
        
        if (state.cart.length === 0) {
            cartItemsContainer.innerHTML = `
                <div class="empty-cart-message">
                    <i class="fa-solid fa-box-open"></i>
                    <p>Your cockpit looks naked! Design a custom stem cap to get started.</p>
                    <a href="#customizer" class="btn btn-primary btn-sm close-drawer-action">Start Designing</a>
                </div>
            `;
            if (cartGrandTotalAmount) cartGrandTotalAmount.textContent = '$0.00 AUD';
            if (checkoutBtn) checkoutBtn.disabled = true;
            const vBtn = document.getElementById('view-cart-btn');
            if (vBtn) vBtn.style.display = 'none';
            return;
        }
        
        if (checkoutBtn) checkoutBtn.disabled = false;
        const vBtn = document.getElementById('view-cart-btn');
        if (vBtn) vBtn.style.display = 'flex';
        
        cartItemsContainer.innerHTML = '';
        
        let cartTotal = 0;
        state.cart.forEach((item, index) => {
            const itemTotal = item.unitPrice * item.qty;
            cartTotal += itemTotal;
            
            const itemElement = document.createElement('div');
            itemElement.className = 'cart-item';
            
            let previewImgHtml = '';
            if (item.preview) {
                previewImgHtml = `<img src="${item.preview}" alt="Product Preview" style="width:100%; height:100%; border-radius:50%; object-fit:cover; border:1px solid var(--border-color);">`;
            } else {
                previewImgHtml = `<div style="width:100%; height:100%; border-radius:50%; background: #1a1c23; border:1px solid var(--border-color);"></div>`;
            }

            let specHtml = '';
            if (item.isPremade) {
                specHtml = `
                    <span class="cart-item-title">${item.title}</span>
                    <span class="cart-item-spec-text">Finish: ${item.colorName}</span>
                    <span class="cart-item-spec-text">Design: Pre-Made Design Series</span>
                    <span class="cart-item-spec-text">Bolt: ${item.boltSelected ? item.boltName : 'Cap Only (No Bolt)'}</span>
                `;
            } else {
                specHtml = `
                    <span class="cart-item-title">Custom 32mm Stem Cap</span>
                    <span class="cart-item-spec-text">Finish: ${item.colorName}</span>
                    <span class="cart-item-spec-text">Design: Custom Engraving Layers</span>
                    <span class="cart-item-spec-text">Bolt: ${item.boltName}</span>
                    ${item.packaging ? '<span class="cart-item-spec-text">Extras: Gift Tin Box</span>' : ''}
                `;
            }
            
            itemElement.innerHTML = `
                <div class="cart-item-preview">
                    ${previewImgHtml}
                </div>
                <div class="cart-item-info">
                    ${specHtml}
                    <span class="cart-item-price">${item.unitPrice.toFixed(2)} AUD <small style="color:var(--text-muted); font-weight:400;">(Qty: ${item.qty})</small></span>
                </div>
                <button class="remove-cart-item" data-index="${index}" aria-label="Remove item">
                    <i class="fa-solid fa-trash-can"></i>
                </button>
            `;
            cartItemsContainer.appendChild(itemElement);
        });
        
        if (cartGrandTotalAmount) cartGrandTotalAmount.textContent = `${cartTotal.toFixed(2)} AUD`;
        
        document.querySelectorAll('.remove-cart-item').forEach(btn => {
            btn.addEventListener('click', () => {
                const idx = parseInt(btn.dataset.index);
                state.cart.splice(idx, 1);
                refreshCartUI();
                showToast('Removed item from your cockpit.', 'fa-trash-can');
            });
        });
    }

    // Helper function to sync local cart state directly to Shopify cart via Ajax
    function syncCartAndRedirect(isCheckout) {
        if (state.cart.length === 0) return;
        
        const checkoutBtn = document.getElementById('checkout-btn');
        const viewCartBtn = document.getElementById('view-cart-btn');
        const btn = isCheckout ? checkoutBtn : viewCartBtn;
        const originalText = btn.innerHTML;
        
        btn.disabled = true;
        btn.innerHTML = 'Updating... <i class="fa-solid fa-spinner fa-spin"></i>';
        showToast('Saving your cockpit configurations...', 'fa-shield-halved');

        const itemsToAdd = [];
        state.cart.forEach(item => {
            if (item.isPremade) {
                // 1. Add pre-made cap variant
                const properties = {};
                if (item.isValves) {
                    properties["Color"] = item.colorName;
                } else {
                    properties["Style"] = item.title;
                    properties["Cap Color"] = item.colorName;
                    properties["Bolt Option"] = item.boltSelected ? item.boltName : "No Bolt Upgrade";
                }
                itemsToAdd.push({
                    id: parseInt(item.variantId),
                    quantity: parseInt(item.qty || 1),
                    properties: properties
                });
                // 2. Add standalone bolt variant if selected
                if (item.boltSelected && item.boltVariantId) {
                    itemsToAdd.push({
                        id: parseInt(item.boltVariantId),
                        quantity: parseInt(item.qty || 1)
                    });
                }
            } else {
                // 1. Add custom cap variant
                const capVariantId = boltVariantMapping[item.bolt] || '48971963531514';
                
                // Build properties
                let textLayers = [];
                let decalsCount = 0;
                let customImagesCount = 0;
                if (canvas && !item.isImported) {
                    // Gather properties dynamically from canvas if active item
                    canvas.getObjects().forEach(obj => {
                        if (obj.type === 'i-text') {
                            textLayers.push(`"${obj.text}" (Font: ${obj.fontFamily}, Curve: ${obj.customCurvature || 0})`);
                        } else if (obj.type === 'group' || obj.type === 'path') {
                            decalsCount++;
                        } else if (obj.type === 'image') {
                            customImagesCount++;
                        }
                    });
                }
                
                const props = {
                    "Design ID": item.designId,
                    "Color Finish": item.colorName,
                    "Bolt Option": item.boltName,
                    "Packaging": item.packaging ? "Premium Gift Tin Box" : "Standard Eco Envelope"
                };
                
                if (item.customText) {
                    props["Custom Text"] = item.customText;
                } else if (textLayers.length > 0) {
                    props["Custom Text"] = textLayers.join(" | ");
                }
                if (decalsCount > 0) props["Decal Graphics"] = `${decalsCount} decal(s)`;
                if (customImagesCount > 0) props["Custom Uploads"] = `${customImagesCount} image(s)`;
                if (item.designService) {
                    props["Expert Design Service"] = "Yes (+$10.00 AUD)";
                    if (item.serviceInstructions) props["Design Instructions"] = item.serviceInstructions;
                    if (item.serviceFileName) props["Reference File"] = item.serviceFileName;
                }
                if (item.previewUrl) props["Design Preview"] = item.previewUrl;
                
                itemsToAdd.push({
                    id: parseInt(capVariantId),
                    quantity: parseInt(item.qty || 1),
                    properties: props
                });
                
                // 2. Add Packaging / Expert Design Service fee variant if selected
                if (item.packaging || item.designService) {
                    itemsToAdd.push({
                        id: 48974995980538,
                        quantity: parseInt(item.qty || 1)
                    });
                }
            }
        });

        // Clear Shopify cart first, then add all items, then redirect
        fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })
        .then(response => {
            if (!response.ok) throw new Error('Failed to clear Shopify cart');
            return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: itemsToAdd })
            });
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(err => {
                    throw new Error(err.description || 'Failed to update Shopify cart.');
                });
            }
            return response.json();
        })
        .then(() => {
            // Clear local storage/state
            state.cart = [];
            refreshCartUI();
            closeCart();
            try {
                sessionStorage.removeItem('cappedout_saved_design');
            } catch (e) {}
            
            // Redirect
            window.location.href = isCheckout ? '/checkout' : '/cart';
        })
        .catch(error => {
            console.error('Error syncing cart:', error);
            btn.disabled = false;
            btn.innerHTML = originalText;
            alert('Something went wrong updating your cart: ' + error.message);
        });
    }

    // Dummy placeholder to keep rest of code clean:

    // Helper to generate a high-fidelity combined PNG preview (base cap + engravings + bolt)
    function generateCombinedPreview(callback) {
        if (canvas) {
            const guides = canvas.getObjects().filter(o => o.isGuide || o.id === 'curvature-guide' || o.id === 'snap-guide-x' || o.id === 'snap-guide-y');
            guides.forEach(g => canvas.remove(g));
            canvas.discardActiveObject();
            canvas.renderAll();
        }
        const size = 300;
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = size;
        tempCanvas.height = size;
        const ctx = tempCanvas.getContext('2d');
        
        const underlayEl = document.getElementById('cap-underlay-svg');
        const fabricCanvasEl = document.getElementById('customizer-canvas');
        const overlayEl = document.getElementById('cap-overlay-svg');
        
        if (!underlayEl || !fabricCanvasEl || !overlayEl || typeof fabric === 'undefined') {
            // Fallback to simple canvas export if elements are missing
            callback(canvas.toDataURL({ format: 'png', quality: 1.0 }));
            return;
        }
        
        function drawSVGElement(svgEl, cb) {
            const svgString = new XMLSerializer().serializeToString(svgEl);
            const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
            const blobUrl = URL.createObjectURL(svgBlob);
            const img = new Image();
            img.onload = function() {
                ctx.drawImage(img, 0, 0, size, size);
                URL.revokeObjectURL(blobUrl);
                cb();
            };
            img.onerror = function(e) {
                console.error("Failed to load SVG layer in combined preview", e);
                URL.revokeObjectURL(blobUrl);
                cb();
            };
            img.src = blobUrl;
        }
        
        // Step 1: Draw the base cap underlay
        drawSVGElement(underlayEl, () => {
            // Step 2: Draw the interactive Fabric canvas (centered at 15, 15 with 270x270 size)
            const fabricImg = new Image();
            fabricImg.onload = function() {
                ctx.drawImage(fabricImg, 15, 15, 270, 270);
                // Step 3: Draw the hex bolt overlay
                drawSVGElement(overlayEl, () => {
                    callback(tempCanvas.toDataURL('image/png', 1.0));
                });
            };
            fabricImg.onerror = function() {
                drawSVGElement(overlayEl, () => {
                    callback(tempCanvas.toDataURL('image/png', 1.0));
                });
            };
            fabricImg.src = canvas.toDataURL({ format: 'png', quality: 1.0 });
        });
    }

    const fontFileMapping = {
        'Another Danger': 'Assets/Fonts/Another Danger - Demo.otf',
        'Another Danger Slanted': 'Assets/Fonts/Another Danger Slanted - Demo.otf',
        'Chalk Board': 'Assets/Fonts/Chalk_Board.ttf',
        'Die Die Die': 'Assets/Fonts/DIEDIEDI.TTF',
        'Road Rage': 'Assets/Fonts/Road_Rage.otf',
        'Metal Mania': 'Assets/Fonts/Metal_Mania.ttf',
        'New Rocker': 'Assets/Fonts/New_Rocker.ttf',
        'Nosifer': 'Assets/Fonts/Nosifer.ttf',
        'Butcherman': 'Assets/Fonts/Butcherman.ttf',
        'Rock Salt': 'Assets/Fonts/Rock_Salt.ttf',
        'Trade Winds': 'Assets/Fonts/Trade_Winds.ttf',
        'Eater': 'Assets/Fonts/Eater.ttf',
        'Outfit': 'Assets/Fonts/Outfit.ttf',
        'Inter': 'Assets/Fonts/Inter.ttf',
        'Lobster': 'Assets/Fonts/Lobster.ttf',
        'Pacifico': 'Assets/Fonts/Pacifico.ttf',
        'Montserrat': 'Assets/Fonts/Montserrat.ttf',
        'Roboto': 'Assets/Fonts/Roboto.ttf',
        'Anton': 'Assets/Fonts/Anton.ttf',
        'Bangers': 'Assets/Fonts/Bangers.ttf',
        'Permanent Marker': 'Assets/Fonts/Permanent_Marker.ttf',
        'Cinzel': 'Assets/Fonts/Cinzel.ttf',
        'Fascinate': 'Assets/Fonts/Fascinate.ttf',
        'Creepster': 'Assets/Fonts/Creepster.ttf',
        'Press Start 2P': 'Assets/Fonts/Press_Start_2P.ttf',
        'Shadows Into Light': 'Assets/Fonts/Shadows_Into_Light.ttf',
        'Righteous': 'Assets/Fonts/Righteous.ttf',
        'Playfair Display': 'Assets/Fonts/Playfair_Display.ttf',
        'Oswald': 'Assets/Fonts/Oswald.ttf',
        'Fredoka One': 'Assets/Fonts/Fredoka_One.ttf',
        'Space Grotesk': 'Assets/Fonts/Space_Grotesk.ttf',
        'Barlow': 'Assets/Fonts/Barlow.ttf'
    };

    // Generates a LightBurn-ready SVG:
    // - Fabric canvas is rendered at 2× onto a BLACK circle background so white text/marks
    //   are always visible (the canvas has a transparent bg — white text would be invisible
    //   in Drive/LightBurn without this).
    // - Vector alignment outlines (red/blue/green) are drawn on top at 1.5px stroke weight.
    function generateEngravingSVG(callback) {
        if (!canvas) {
            callback('');
            return;
        }

        const scale = 2.0; // 2x resolution is sharper for tracing
        const canvasW = canvas.getWidth();   // 270
        const canvasH = canvas.getHeight();  // 270
        const scaledW = canvasW * scale;     // 540
        const scaledH = canvasH * scale;     // 540

        // Grab the Fabric canvas render (strip any temporary guides & active selection handles first)
        const guides = canvas.getObjects().filter(o => o.isGuide || o.id === 'curvature-guide' || o.id === 'snap-guide-x' || o.id === 'snap-guide-y');
        guides.forEach(g => canvas.remove(g));
        canvas.discardActiveObject();
        canvas.renderAll();
        const fabricDataUrl = canvas.toDataURL({ format: 'png', quality: 1.0, multiplier: scale });

        const img = new Image();
        img.onload = async function() {
            // Check if PotracePlus is available
            if (typeof PotracePlus !== 'undefined') {
                try {
                    // Create an offscreen high-contrast canvas for Potrace
                    const tempCanvas = document.createElement('canvas');
                    tempCanvas.width  = scaledW;
                    tempCanvas.height = scaledH;
                    const ctx = tempCanvas.getContext('2d');
                    
                    // Draw our design image (with its original transparent background)
                    ctx.drawImage(img, 0, 0);
                    
                    // Convert pixels to binary B&W (white background, black text/shapes)
                    const imgData = ctx.getImageData(0, 0, scaledW, scaledH);
                    const data = imgData.data;
                    for (let i = 0; i < data.length; i += 4) {
                        const a = data[i+3];
                        
                        // If transparent or near-transparent, make it pure white background
                        if (a < 128) {
                            data[i]   = 255;
                            data[i+1] = 255;
                            data[i+2] = 255;
                            data[i+3] = 255;
                        } else {
                            // Otherwise (opaque design elements), make it pure black
                            data[i]   = 0;
                            data[i+1] = 0;
                            data[i+2] = 0;
                            data[i+3] = 255;
                        }
                    }
                    ctx.putImageData(imgData, 0, 0);
                    
                    // Run Potrace tracing
                    const options = {
                        turdsize: 2,
                        optcurve: true,
                        alphamax: 1.0,
                        opttolerance: 0.2,
                        optimize: true
                    };
                    const traced = await PotracePlus(tempCanvas, options);
                    const pathData = traced.d;
                    
                    // Build SVG — use full scaled (540x540) coordinate space so the
                    // Potrace path data and alignment circles are in the SAME space.
                    // The laser software will scale the SVG to fit the physical cap.
                    const svgW  = scaledW;   // 540
                    const svgH  = scaledH;   // 540
                    const cx    = svgW / 2;  // 270
                    const cy    = svgH / 2;  // 270
                    const boltR = 44 * scale; // 88  (bolt head, scaled up)
                    const hexPts = [
                        [cx,              cy - 12 * scale],
                        [cx + 10.39*scale, cy -  6 * scale],
                        [cx + 10.39*scale, cy +  6 * scale],
                        [cx,              cy + 12 * scale],
                        [cx - 10.39*scale, cy +  6 * scale],
                        [cx - 10.39*scale, cy -  6 * scale]
                    ].map(p => p.join(',')).join(' ');

                    const svgContent = [
                        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${svgW} ${svgH}" width="${svgW}" height="${svgH}">`,
                        `  <!-- Design: clean outlined vector paths -->`,
                        `  <path d="${pathData}" fill="#000000" fill-rule="evenodd" />`,
                        `  <!-- Laser alignment guides — Blue=bolt head | Green=hex socket -->`,
                        `  <circle cx="${cx}" cy="${cy}" r="${boltR}" fill="none" stroke="#0000ff" stroke-width="1.5" id="bolt-alignment-outline" />`,
                        `  <polygon points="${hexPts}" fill="none" stroke="#00ff00" stroke-width="1.5" id="hex-alignment-outline" />`,
                        `</svg>`
                    ].join('\n');
                    
                    callback('data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent));
                    return;
                } catch (traceError) {
                    console.warn("Potrace vector tracing failed, falling back to raster:", traceError);
                }
            }

            // --- PLAN B: Raster-in-SVG Fallback ---
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width  = scaledW;
            tempCanvas.height = scaledH;
            const ctx = tempCanvas.getContext('2d');
            
            // Draw black circle cap background
            const cxPx = scaledW / 2;
            const cyPx = scaledH / 2;
            ctx.save();
            ctx.beginPath();
            ctx.arc(cxPx, cyPx, scaledW / 2, 0, Math.PI * 2);
            ctx.fillStyle = '#0a0a0a';
            ctx.fill();
            ctx.restore();
            
            // Draw Fabric design canvas
            ctx.drawImage(img, 0, 0, scaledW, scaledH);
            const embeddedPng = tempCanvas.toDataURL('image/png');
            
            const cx   = canvasW / 2;  // 135
            const cy   = canvasH / 2;  // 135
            const boltR = 44;
            const hexPts = [
                [cx,         cy - 12],
                [cx + 10.39, cy -  6],
                [cx + 10.39, cy +  6],
                [cx,         cy + 12],
                [cx - 10.39, cy +  6],
                [cx - 10.39, cy -  6]
            ].map(p => p.join(',')).join(' ');
            
            const svgContent = [
                `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"`,
                `     viewBox="0 0 ${canvasW} ${canvasH}" width="${canvasW}" height="${canvasH}">`,
                `  <!-- Design: black cap bg + Fabric 2x render (raster fallback) -->`,
                `  <image x="0" y="0" width="${canvasW}" height="${canvasH}"`,
                `         xlink:href="${embeddedPng}" />`,
                `  <!-- Laser alignment guides — Blue=bolt head | Green=hex socket -->`,
                `  <circle cx="${cx}" cy="${cy}" r="${boltR}" fill="none" stroke="#0000ff" stroke-width="1.5" id="bolt-alignment-outline" />`,
                `  <polygon points="${hexPts}" fill="none" stroke="#00ff00" stroke-width="1.5" id="hex-alignment-outline" />`,
                `</svg>`
            ].join('\n');
            
            callback('data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent));
        };
        img.onerror = function() {
            const cx = canvas.getWidth() / 2;
            const cy = canvas.getHeight() / 2;
            const svgContent = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 270 270"></svg>`;
            callback('data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgContent));
        };
        img.src = fabricDataUrl;
    }

    function outlineAllCanvasText(clonedCanvas, callback) {
        if (typeof opentype === 'undefined') {
            console.warn("opentype.js is not loaded, skipping text outlining.");
            callback();
            return;
        }
        
        const textObjects = clonedCanvas.getObjects().filter(obj => obj.type === 'i-text' || obj.type === 'text');
        
        if (textObjects.length === 0) {
            callback();
            return;
        }
        
        let promises = textObjects.map(textObj => {
            return new Promise((resolve) => {
                const fontFamily = textObj.fontFamily;
                let fontUrl = fontFileMapping[fontFamily] || 'Assets/Fonts/Outfit.ttf';
                if (window.CappedOutAssets && window.CappedOutAssets.fonts && window.CappedOutAssets.fonts[fontFamily]) {
                    fontUrl = window.CappedOutAssets.fonts[fontFamily];
                }
                
                opentype.load(fontUrl, function(err, font) {
                    if (err) {
                        console.error('Could not load font for outlining:', fontFamily, err);
                        resolve(); // Resolve anyway to not block
                        return;
                    }
                    
                    const text = textObj.text || '';
                    const fontSize = textObj.fontSize || 22;
                    const val = textObj.customCurvature || 0;
                    
                    if (val === 0) {
                        // Flat text
                        const path = font.getPath(text, 0, 0, fontSize);
                        const pathData = path.toPathData();
                        if (pathData.trim() === '') {
                            clonedCanvas.remove(textObj);
                            resolve();
                            return;
                        }
                        
                        const outlinedPath = new fabric.Path(pathData, {
                            fill: textObj.fill || '#ffffff',
                            stroke: textObj.stroke,
                            strokeWidth: textObj.strokeWidth,
                            left: textObj.left,
                            top: textObj.top,
                            angle: textObj.angle,
                            originX: 'center',
                            originY: 'center'
                        });
                        
                        clonedCanvas.add(outlinedPath);
                        clonedCanvas.remove(textObj);
                        resolve();
                    } else {
                        // Curved text
                        const chars = text.split('');
                        const N = chars.length;
                        const wrapDeg = Math.abs(val);
                        const theta = (wrapDeg / 360) * 2 * Math.PI;
                        const R = 90; // curve radius
                        
                        // Calculate spacing factor (matching applyTextCurvature spacing)
                        const spacingFactor = 150 + Math.round((wrapDeg / 360) * 250);
                        const letterSpacing = fontSize * (spacingFactor / 1000);
                        
                        // Calculate character widths and total width
                        let totalWidth = 0;
                        const widths = chars.map(c => {
                            const w = font.getAdvanceWidth(c, fontSize);
                            totalWidth += w;
                            return w;
                        });
                        const totalWidthWithSpacing = totalWidth + (N - 1) * letterSpacing;
                        const linearToAngle = theta / (totalWidthWithSpacing || 1);
                        
                        const paths = [];
                        let currentX = 0;
                        
                        for (let i = 0; i < N; i++) {
                            const char = chars[i];
                            const charWidth = widths[i];
                            const midX = currentX + charWidth / 2;
                            const angleOffset = midX * linearToAngle;
                            
                            let charAngle;
                            let rotationAngle;
                            
                            if (val > 0) {
                                charAngle = (1.5 * Math.PI - (theta / 2)) + angleOffset;
                                rotationAngle = charAngle - 1.5 * Math.PI;
                            } else {
                                charAngle = (0.5 * Math.PI + (theta / 2)) - angleOffset;
                                rotationAngle = charAngle - 0.5 * Math.PI;
                            }
                            
                            const cx = 0;
                            const cy = val > 0 ? R : -R;
                            
                            const x = cx + R * Math.cos(charAngle);
                            const y = cy + R * Math.sin(charAngle);
                            
                            currentX += charWidth + letterSpacing;
                            
                            const charPath = font.getPath(char, 0, 0, fontSize);
                            const charPathData = charPath.toPathData();
                            
                            if (charPathData.trim() === '') continue; // Skip space characters
                            
                            const fabricCharPath = new fabric.Path(charPathData, {
                                fill: textObj.fill || '#ffffff',
                                stroke: textObj.stroke,
                                strokeWidth: textObj.strokeWidth,
                                originX: 'center',
                                originY: 'center',
                                left: x,
                                top: y,
                                angle: rotationAngle * 180 / Math.PI
                            });
                            
                            paths.push(fabricCharPath);
                        }
                        
                        if (paths.length > 0) {
                            const group = new fabric.Group(paths, {
                                left: textObj.left,
                                top: textObj.top,
                                angle: textObj.angle,
                                originX: 'center',
                                originY: 'center'
                            });
                            clonedCanvas.add(group);
                        }
                        clonedCanvas.remove(textObj);
                        resolve();
                    }
                });
            });
        });
        
        Promise.all(promises).then(() => {
            callback();
        });
    }

    // (generateEngravingSVG defined above)

    if (addToCartBtn) {
        addToCartBtn.addEventListener('click', () => {
            const customizerSpec = state.customizer;
            const unitPrice = getCustomizerTotalPrice();
            
            // Disable button briefly to prevent double clicks during generation
            addToCartBtn.disabled = true;
            const originalHtml = addToCartBtn.innerHTML;
            addToCartBtn.innerHTML = 'Adding... <i class="fa-solid fa-spinner fa-spin"></i>';
            
            // Export canvas layers to outlined vector SVG
            generateEngravingSVG(engravingSVGDataUrl => {
                // Generate high-fidelity combined preview image asynchronously
                generateCombinedPreview(combinedPng => {
                    const designId = 'CO-DESIGN-' + Math.floor(10000000 + Math.random() * 90000000);
                    const googleScriptUrl = "https://script.google.com/macros/s/AKfycbz48HeA3gSw07Xtj5e3P5zMl5YsEfccqXdiSX2JX9hKSCXHKNx7xNtNFN8ND5_asWz41g/exec";
                    const hasScript = googleScriptUrl && !googleScriptUrl.includes("PLACEHOLDER");
                    
                    const sendAddToCartMessage = (previewUrl = '') => {
                        const customTextSummary = canvas ? canvas.getObjects().filter(o => o.type === 'i-text').map(o => o.text).join(' | ') : '';
                        const cartItem = {
                            id: 'cap-' + Date.now(),
                            designId: designId,
                            color: customizerSpec.color,
                            colorName: customizerSpec.colorName,
                            bolt: customizerSpec.bolt,
                            boltName: customizerSpec.boltName,
                            packaging: customizerSpec.packaging,
                            designService: customizerSpec.designService,
                            serviceInstructions: customizerSpec.serviceInstructions,
                            serviceFileName: customizerSpec.serviceFileName,
                            customText: customTextSummary,
                            unitPrice: unitPrice,
                            preview: combinedPng, // Use high-fidelity combined PNG
                            previewUrl: previewUrl, // Store Google Drive preview URL for syncCartAndRedirect
                            svgData: engravingSVGDataUrl,
                            qty: 1
                        };
                        
                        state.cart.push(cartItem);
                        refreshCartUI();
                        
                        // Shopify Cart API Integration
                        const capVariantId = boltVariantMapping[customizerSpec.bolt] || '48971963531514';
                        
                        const properties = {
                            "Design ID": designId,
                            "Color Finish": customizerSpec.colorName,
                            "Bolt Option": customizerSpec.boltName,
                            "Packaging": customizerSpec.packaging ? "Premium Gift Tin Box" : "Standard Eco Envelope",
                            "Custom Text": customTextSummary
                            // NOTE: Full design files (SVG + PNG) are uploaded to Google Drive separately.
                            // Only the short Drive preview URL is added below once upload completes.
                        };
                        
                        if (customizerSpec.designService) {
                            properties["Expert Design Service"] = "Yes (+$10.00 AUD)";
                            if (customizerSpec.serviceInstructions) properties["Design Instructions"] = customizerSpec.serviceInstructions;
                            if (customizerSpec.serviceFileName) properties["Reference File"] = customizerSpec.serviceFileName;
                        }
                        
                        if (previewUrl) {
                            properties["Design Preview"] = previewUrl;
                        }
                        
                        if (window.parent && window.parent !== window) {
                            const messagePayload = {
                                action: 'ADD_TO_CART',
                                variantId: parseInt(capVariantId),
                                properties: properties
                            };
                            window.parent.postMessage(messagePayload, '*');
                        } else {
                            // Also add directly to Shopify /cart/add.js in the background so if the user navigates to /cart via header/nav, their custom cap & Design ID are already in Shopify's cart!
                            const directItems = [{
                                id: parseInt(capVariantId),
                                quantity: 1,
                                properties: properties
                            }];
                            if (customizerSpec.packaging || customizerSpec.designService) {
                                directItems.push({
                                    id: 48974995980538,
                                    quantity: 1
                                });
                            }
                            fetch('/cart/add.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ items: directItems })
                            }).catch(err => console.warn('Background cart sync warning:', err));
                        }
                        
                        // Clear saved design from sessionStorage since it has been added to cart
                        try {
                            sessionStorage.removeItem('cappedout_saved_design');
                        } catch (e) {}
                        
                        // Re-enable button
                        addToCartBtn.disabled = false;
                        addToCartBtn.innerHTML = originalHtml;
                        
                        if (isEmbed) {
                            showToast('Adding custom cap to your Shopify cart...', 'fa-circle-check');
                        } else {
                            showToast('Added custom cap to your cockpit! Ready to shred.', 'fa-circle-check');
                            openCart();
                        }
                        goToStep(1);
                    };
                    
                    if (hasScript) {
                        // Await design upload to Google Drive to prevent race condition/abort on redirect
                        fetch(googleScriptUrl, {
                            method: 'POST',
                            headers: { 'Content-Type': 'text/plain' },
                            body: JSON.stringify({
                                action:   'pre_upload',
                                designId: designId,
                                name:     'Custom Cap (' + customizerSpec.colorName + ')',
                                svgData:  engravingSVGDataUrl,
                                pngData:  combinedPng
                            })
                        })
                        .then(res => res.json())
                        .then(data => {
                            const driveUrl = data.previewUrl || '';
                            sendAddToCartMessage(driveUrl);
                        })
                        .catch(err => {
                            console.warn('Design upload failed:', err);
                            // Fallback so checkout isn't blocked if upload fails
                            sendAddToCartMessage('');
                        });
                    } else {
                        sendAddToCartMessage();
                    }
                });
            });
        });
    }


    if (checkoutBtn) {
        checkoutBtn.addEventListener('click', () => {
            if (state.cart.length === 0) return;
            syncCartAndRedirect(true);
        });
    }
    
    // Wire up the View / Edit Cart button
    const viewCartBtn = document.getElementById('view-cart-btn');
    if (viewCartBtn) {
        viewCartBtn.addEventListener('click', () => {
            if (state.cart.length === 0) return;
            syncCartAndRedirect(false);
        });
    }
    
    // === PRE-MADE QUICK SHOP MODAL CONTROLLER ===
    const premadeModal = document.getElementById('premade-quick-shop-modal');
    const closePremadeModalBtn = document.getElementById('close-premade-modal');
    const premadeCapColorSelect = document.getElementById('premade-cap-color');
    const premadeBoltCheckbox = document.getElementById('premade-bolt-checkbox');
    const premadeBoltColorContainer = document.getElementById('premade-bolt-color-select-container');
    const premadeBoltColorSelect = document.getElementById('premade-bolt-color');
    const premadeAddToCartBtn = document.getElementById('premade-add-to-cart-btn');
    
    let activePremadeProduct = null;
    let activePremadeHandle = '';
    let activePremadeImage = '';
    let activePremadeTitle = '';

    // Handle Quick Add trigger
    document.querySelectorAll('.premade-buy-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            const handle = btn.dataset.handle;
            
            if (handle && handle.includes('full-colour')) {
                window.location.href = `/products/${handle}`;
                return;
            }
            
            const title = btn.dataset.title;
            const image = btn.dataset.image;
            
            activePremadeHandle = handle;
            activePremadeTitle = title;
            activePremadeImage = image;
            
            // Set basic modal details
            document.getElementById('premade-modal-title').textContent = title;
            document.getElementById('premade-modal-image').src = image;
            
            const isValves = handle === 'tubless-valves';
            const priceSpan = premadeModal.querySelector('span[style*="var(--accent)"]');
            if (priceSpan) {
                priceSpan.textContent = isValves ? '$40.00 AUD' : '$25.00 AUD';
            }
            
            // Open modal
            if (premadeModal) {
                premadeModal.style.display = 'flex';
                setTimeout(() => {
                    premadeModal.style.opacity = '1';
                    premadeModal.querySelector('.modal-container').style.transform = 'scale(1)';
                }, 10);
            }
            
            // Show loading, hide form
            document.getElementById('premade-modal-loading').style.display = 'block';
            document.getElementById('premade-modal-form').style.display = 'none';
            
            // Fetch product options dynamically
            fetch(`/products/${handle}.js`)
                .then(r => {
                    if (!r.ok) throw new Error('Product details fetch failed');
                    return r.json();
                })
                .then(product => {
                    activePremadeProduct = product;
                    
                    const isValves = handle === 'tubless-valves';
                    
                    // Update form labels
                    const colorLabel = document.querySelector('label[for="premade-cap-color"]');
                    if (colorLabel) {
                        colorLabel.textContent = isValves ? 'Valve Color Finish:' : 'Cap Color Finish:';
                    }
                    
                    // Hide/Show bolt options
                    const boltSection = premadeBoltCheckbox ? premadeBoltCheckbox.closest('div') : null;
                    if (boltSection) {
                        boltSection.style.display = isValves ? 'none' : 'block';
                    }
                    
                    // Clear and populate cap colors dropdown
                    premadeCapColorSelect.innerHTML = '';
                    const preselectedColor = (btn.dataset.selectedColor || '').toLowerCase();
                    let matchedIndex = 0;
                    product.variants.forEach((variant, idx) => {
                        const opt = document.createElement('option');
                        opt.value = variant.id;
                        opt.textContent = variant.title; // e.g. "Black" or "Anodized Silver"
                        opt.dataset.price = variant.price;
                        if (preselectedColor && variant.title.toLowerCase().includes(preselectedColor)) {
                            matchedIndex = idx;
                        }
                        premadeCapColorSelect.appendChild(opt);
                    });
                    premadeCapColorSelect.selectedIndex = matchedIndex;
                    
                    // Reset bolt options
                    premadeBoltCheckbox.checked = false;
                    premadeBoltColorContainer.style.display = 'none';
                    
                    // Hide loading, show options form
                    document.getElementById('premade-modal-loading').style.display = 'none';
                    document.getElementById('premade-modal-form').style.display = 'flex';
                })
                .catch(err => {
                    console.error('Failed to load pre-made product JSON:', err);
                    showToast('Failed to load cap colors. Adding standard variant.', 'fa-triangle-exclamation');
                    
                    // Direct fallback addition without variants
                    const mockVariantId = '48971963531514'; // base default cap variant
                    const cartItem = {
                        id: 'premade-' + Date.now(),
                        isPremade: true,
                        variantId: mockVariantId,
                        title: activePremadeTitle,
                        colorName: 'Default Finish',
                        unitPrice: isValves ? 40.00 : 25.00,
                        preview: activePremadeImage,
                        qty: 1,
                        boltSelected: false
                    };
                    state.cart.push(cartItem);
                    refreshCartUI();
                    if (premadeModal) closeModal();
                    openCart();
                });
        });
    });

    function closeModal() {
        if (premadeModal) {
            premadeModal.style.opacity = '0';
            premadeModal.querySelector('.modal-container').style.transform = 'scale(0.9)';
            setTimeout(() => {
                premadeModal.style.display = 'none';
            }, 300);
        }
    }

    if (closePremadeModalBtn) {
        closePremadeModalBtn.addEventListener('click', closeModal);
    }
    if (premadeModal) {
        premadeModal.addEventListener('click', (e) => {
            if (e.target === premadeModal) closeModal();
        });
    }

    // Toggle bolt options
    if (premadeBoltCheckbox) {
        premadeBoltCheckbox.addEventListener('change', () => {
            premadeBoltColorContainer.style.display = premadeBoltCheckbox.checked ? 'block' : 'none';
        });
    }

    // Add Premade item to local cart state
    if (premadeAddToCartBtn) {
        premadeAddToCartBtn.addEventListener('click', () => {
            const selectedCapVariantId = premadeCapColorSelect.value;
            const selectedColorText = premadeCapColorSelect.options[premadeCapColorSelect.selectedIndex].textContent;
            
            const isBoltChecked = premadeBoltCheckbox && premadeBoltCheckbox.checked;
            let boltName = '';
            let boltVariantId = '';
            
            if (isBoltChecked) {
                boltVariantId = premadeBoltColorSelect.value;
                boltName = premadeBoltColorSelect.options[premadeBoltColorSelect.selectedIndex].dataset.name || premadeBoltColorSelect.options[premadeBoltColorSelect.selectedIndex].textContent;
            }
            
            const isValves = activePremadeHandle === 'tubless-valves';
            const selectedOption = premadeCapColorSelect.options[premadeCapColorSelect.selectedIndex];
            const basePrice = (selectedOption && selectedOption.dataset.price) ? (parseFloat(selectedOption.dataset.price) / 100.0) : (isValves ? 40.00 : 25.00);
            const unitPrice = basePrice + (isBoltChecked ? 10.00 : 0.00);
            
            const cartItem = {
                id: 'premade-' + Date.now(),
                isPremade: true,
                variantId: selectedCapVariantId,
                title: activePremadeTitle,
                colorName: selectedColorText,
                unitPrice: unitPrice,
                preview: activePremadeImage,
                qty: 1,
                boltSelected: isValves ? false : isBoltChecked,
                boltName: isValves ? '' : boltName,
                boltVariantId: isValves ? '' : boltVariantId,
                isValves: isValves
            };
            
            state.cart.push(cartItem);
            refreshCartUI();
            closeModal();
            showToast('Added pre-designed cap to your cockpit!', 'fa-circle-check');
            openCart();
        });
    }

    // === B2B WHOLESALE PORTAL CALCULATOR ===
    
    function getWholesalePricing(qty) {
        let pricePerCap = 30.00;
        let discountPercent = 0;
        if (qty >= 100) {
            pricePerCap = 18.00;
            discountPercent = 48;
        } else if (qty >= 25) {
            pricePerCap = 22.00;
            discountPercent = 37;
        } else if (qty >= 10) {
            pricePerCap = 28.00;
            discountPercent = 20;
        }
        return { pricePerCap, discountPercent };
    }

    function getWholesaleBoltPrice(boltType) {
        switch (boltType) {
            case 'ti-oilslick': return 8.00;
            case 'ti-gold':
            case 'ti-blue':
            case 'ti-black': return 6.00;
            default: return 0.00;
        }
    }

    function updateB2BWholesaleUI() {
        if (!b2bForm) return;
        const qty = parseInt(b2bQtyInput.value) || 100;
        const boltType = b2bBoltSelect ? b2bBoltSelect.value : 'steel';
        
        const { pricePerCap, discountPercent } = getWholesalePricing(qty);
        const boltPrice = getWholesaleBoltPrice(boltType);
        
        const rows = document.querySelectorAll('.tier-row');
        rows.forEach(row => {
            row.classList.remove('active');
            const min = parseInt(row.dataset.min);
            const max = parseInt(row.dataset.max);
            if (qty >= min && qty <= max) {
                row.classList.add('active');
            }
        });
        
        if (calcUnitPrice) calcUnitPrice.textContent = `$${pricePerCap.toFixed(2)} AUD`;
        if (calcBoltUnitPrice) calcBoltUnitPrice.textContent = `$${boltPrice.toFixed(2)} AUD`;
        
        if (calcDiscountPercent) {
            if (discountPercent > 0) {
                calcDiscountPercent.textContent = `${discountPercent}% Saved`;
                calcDiscountPercent.style.color = '#ff0033';
            } else {
                calcDiscountPercent.textContent = 'Base Pricing';
                calcDiscountPercent.style.color = 'var(--text-muted)';
            }
        }
        
        const total = (pricePerCap + boltPrice) * qty;
        if (calcGrandTotal) {
            calcGrandTotal.textContent = `$${total.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} AUD`;
        }
    }

    if (b2bForm) {
        // Wholesale Access Passcode check
        const loginForm = document.getElementById('b2b-login-form');
        const loginWall = document.getElementById('b2b-login-wall');
        const b2bContent = document.getElementById('b2b-wholesale-content');

        if (sessionStorage.getItem('b2b_logged_in') === 'true') {
            if (loginWall) loginWall.style.display = 'none';
            if (b2bContent) b2bContent.style.display = 'grid';
        }

        if (loginForm) {
            loginForm.addEventListener('submit', (e) => {
                e.preventDefault();
                const passcode = document.getElementById('wholesale-passcode').value.trim();
                
                if (passcode.toUpperCase() === 'CO-DEALER-2026') {
                    sessionStorage.setItem('b2b_logged_in', 'true');
                    showToast('Credentials verified! Welcome back.', 'fa-circle-check');
                    
                    if (loginWall) {
                        loginWall.style.transition = 'opacity 0.4s ease';
                        loginWall.style.opacity = '0';
                        setTimeout(() => {
                            loginWall.style.display = 'none';
                            if (b2bContent) {
                                b2bContent.style.display = 'grid';
                                b2bContent.style.opacity = '0';
                                b2bContent.style.transition = 'opacity 0.4s ease';
                                setTimeout(() => { b2bContent.style.opacity = '1'; }, 50);
                            }
                        }, 400);
                    }
                } else {
                    showToast('Invalid passcode. Access Denied.', 'fa-circle-exclamation');
                    alert('Error: The passcode entered is invalid.\nPlease contact crew@cappedout.com.au for approved access.');
                }
            });
        }

        // Qty stepper handlers
        if (b2bQtyDecBtn) {
            b2bQtyDecBtn.addEventListener('click', () => {
                let val = parseInt(b2bQtyInput.value) || 100;
                if (val > 5) {
                    b2bQtyInput.value = val - 5;
                    updateB2BWholesaleUI();
                }
            });
        }

        if (b2bQtyIncBtn) {
            b2bQtyIncBtn.addEventListener('click', () => {
                let val = parseInt(b2bQtyInput.value) || 100;
                b2bQtyInput.value = val + 5;
                updateB2BWholesaleUI();
            });
        }

        if (b2bQtyInput) {
            b2bQtyInput.addEventListener('input', () => {
                let val = parseInt(b2bQtyInput.value);
                if (!isNaN(val) && val >= 5) updateB2BWholesaleUI();
            });

            b2bQtyInput.addEventListener('change', () => {
                let val = parseInt(b2bQtyInput.value);
                if (isNaN(val) || val < 5) b2bQtyInput.value = 5;
                updateB2BWholesaleUI();
            });
        }

        if (b2bCapColorSelect) b2bCapColorSelect.addEventListener('change', updateB2BWholesaleUI);
        if (b2bBoltSelect) b2bBoltSelect.addEventListener('change', updateB2BWholesaleUI);

        // simulated file uploads
        const dropzoneInput = document.getElementById('b2b-logo-file');
        if (fileDropzone && dropzoneInput) {
            const uploadPrompt = fileDropzone.querySelector('.upload-prompt');
            const uploadSuccess = fileDropzone.querySelector('.upload-success');
            const successFilename = document.getElementById('success-filename');
            const removeFileBtn = document.getElementById('remove-file-btn');

            function handleFile(file) {
                if (file) {
                    if (successFilename) successFilename.textContent = `${file.name} (${(file.size / 1024).toFixed(1)} KB)`;
                    if (uploadPrompt) uploadPrompt.style.display = 'none';
                    if (uploadSuccess) uploadSuccess.style.display = 'block';
                    fileDropzone.style.borderColor = 'var(--accent)';
                    showToast('Vector file uploaded successfully!', 'fa-cloud-arrow-up');
                }
            }

            dropzoneInput.addEventListener('change', (e) => {
                handleFile(e.target.files[0]);
            });

            fileDropzone.addEventListener('dragover', (e) => {
                e.preventDefault();
                fileDropzone.style.borderColor = '#ff0033';
            });

            fileDropzone.addEventListener('dragleave', () => {
                fileDropzone.style.borderColor = 'rgba(255, 255, 255, 0.15)';
            });

            fileDropzone.addEventListener('drop', (e) => {
                e.preventDefault();
                const file = e.dataTransfer.files[0];
                handleFile(file);
            });

            if (removeFileBtn) {
                removeFileBtn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    dropzoneInput.value = '';
                    if (uploadPrompt) uploadPrompt.style.display = 'block';
                    if (uploadSuccess) uploadSuccess.style.display = 'none';
                    fileDropzone.style.borderColor = 'rgba(255, 255, 255, 0.15)';
                    showToast('Logo file removed.', 'fa-trash-can');
                });
            }
        }

        b2bForm.addEventListener('submit', (e) => {
            e.preventDefault();
            const qty = b2bQtyInput.value;
            const color = b2bCapColorSelect.options[b2bCapColorSelect.selectedIndex].text;
            const bolt = b2bBoltSelect ? b2bBoltSelect.options[b2bBoltSelect.selectedIndex].text : 'Standard Steel Bolt';
            const name = document.getElementById('b2b-name').value;
            const email = document.getElementById('b2b-email').value;
            const company = document.getElementById('b2b-company').value;
            const grandTotal = calcGrandTotal.textContent;
            
            const submitBtn = document.getElementById('b2b-submit-btn');
            submitBtn.disabled = true;
            submitBtn.innerHTML = 'Sending Quote Request... <i class="fa-solid fa-spinner fa-spin"></i>';

            const formData = new FormData();
            formData.append('Quantity', qty);
            formData.append('Cap Color', color);
            formData.append('Bolt Style', bolt);
            formData.append('Contact Name', name);
            formData.append('Email', email);
            formData.append('Company/Club', company);
            formData.append('Wholesale Price Estimate', grandTotal);
            
            fetch('https://formspree.io/f/xwvjeqra', {
                method: 'POST',
                body: formData,
                headers: {
                    'Accept': 'application/json'
                }
            })
            .then(response => {
                if (response.ok) {
                    showToast('Wholesale quote request submitted!', 'fa-paper-plane');
                    alert(`Thank you, ${name}!\nYour wholesale quote request for ${qty} caps has been submitted.\nWe will review your uploaded vector logo details and reply to ${email} within 24 hours.`);
                    b2bForm.reset();
                    const removeFileBtn = document.getElementById('remove-file-btn');
                    if (removeFileBtn) removeFileBtn.click();
                    updateB2BWholesaleUI();
                } else {
                    throw new Error('Formspree returned error status');
                }
            })
            .catch(err => {
                console.error('Error submitting form:', err);
                showToast('Simulated Wholesale request success (offline mode)', 'fa-circle-check');
                alert(`Offline Demo: Thank you, ${name}!\nYour wholesale quote request for ${qty} caps was processed successfully.\nEstimated Total: ${grandTotal}`);
            })
            .finally(() => {
                submitBtn.disabled = false;
                submitBtn.innerHTML = 'Submit Wholesale Quote Request <i class="fa-solid fa-paper-plane"></i>';
            });
        });
    }

    // === INITIALIZATION RUNS ===
    if (capBase) {
        goToStep(1);
        renderCustomizer();
    }
    // === MOBILE LIVE TOOLBOX SETUP ===
    // Tab switching logic
    document.querySelectorAll('.mobile-tab-btn').forEach(btn => {
        btn.addEventListener('click', () => {
            document.querySelectorAll('.mobile-tab-btn').forEach(b => b.classList.remove('active'));
            document.querySelectorAll('.mobile-tab-content').forEach(c => c.classList.remove('active'));
            
            btn.classList.add('active');
            const targetId = btn.dataset.mobileTab;
            const targetContent = document.getElementById(targetId);
            if (targetContent) {
                targetContent.classList.add('active');
            }
        });
    });

    // Mobile Add Text button click routing
    document.querySelectorAll('.m-btn-add-text').forEach(btn => {
        btn.addEventListener('click', () => {
            if (btnAddText) btnAddText.click();
        });
    });

    // Mobile text input proxying to desktop editor
    const mobileEditorTextContent = document.getElementById('mobile-editor-text-content');
    if (mobileEditorTextContent) {
        mobileEditorTextContent.addEventListener('input', (e) => {
            const desktopInput = document.getElementById('editor-text-content');
            if (desktopInput) {
                desktopInput.value = e.target.value;
                // Dispatch input event to update Fabric object
                desktopInput.dispatchEvent(new Event('input'));
            }
        });
    }

    // Mobile outline style button proxying
    const mobileBtnOutline = document.getElementById('mobile-btn-text-outline');
    if (mobileBtnOutline) {
        mobileBtnOutline.addEventListener('click', () => {
            const desktopOutlineBtn = document.getElementById('btn-text-outline');
            if (desktopOutlineBtn) {
                desktopOutlineBtn.click();
            }
        });
    }

    // Mobile font selector triggers desktop select & custom dropdown
    const mobileFontTrigger = document.getElementById('mobile-font-select-trigger');
    const mobileFontList = document.getElementById('mobile-font-dropdown-list');
    if (mobileFontTrigger && mobileFontList) {
        mobileFontTrigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const isVisible = mobileFontList.style.display === 'block';
            // Hide other list
            const fontList = document.getElementById('custom-font-dropdown-list');
            if (fontList) fontList.style.display = 'none';
            
            mobileFontList.style.display = isVisible ? 'none' : 'block';
        });
    }

    // Mobile custom file input proxying to desktop decal logo input
    const mobileDecalFile = document.getElementById('mobile-decal-logo-file');
    if (mobileDecalFile) {
        mobileDecalFile.addEventListener('change', (e) => {
            const desktopInput = document.getElementById('decal-logo-file');
            if (desktopInput && e.target.files.length > 0) {
                const dt = new DataTransfer();
                dt.items.add(e.target.files[0]);
                desktopInput.files = dt.files;
                desktopInput.dispatchEvent(new Event('change'));
            }
        });
    }

    // === ABOUT PHOTOS SLIDESHOWS ===
    function initSlideshow(containerSelector, intervalTime = 4000) {
        const container = document.querySelector(containerSelector);
        if (!container) return;
        
        const slides = container.querySelectorAll('.slide');
        const dots = container.querySelectorAll('.dot');
        if (slides.length === 0) return;
        
        let currentSlide = 0;
        function showSlide(index) {
            slides.forEach((s, idx) => {
                s.classList.remove('active');
                if (dots[idx]) dots[idx].classList.remove('active');
            });
            slides[index].classList.add('active');
            if (dots[index]) dots[index].classList.add('active');
        }
        
        let slideInterval = setInterval(() => {
            currentSlide = (currentSlide + 1) % slides.length;
            showSlide(currentSlide);
        }, intervalTime);
        
        dots.forEach((dot, idx) => {
            dot.addEventListener('click', () => {
                clearInterval(slideInterval);
                currentSlide = idx;
                showSlide(currentSlide);
                slideInterval = setInterval(() => {
                    currentSlide = (currentSlide + 1) % slides.length;
                    showSlide(currentSlide);
                }, intervalTime);
            });
        });
    }

    initSlideshow('.hero-slideshow', 4800);   // Slow fade for tinted top hero showcase
    initSlideshow('.bottom-slideshow', 4000); // Smooth cycle for other assets

    if (b2bForm) {
        updateB2BWholesaleUI();
    }

    // === MOBILE BOTTOM NAVIGATION LOGIC (Hideout-style) ===
    const mobileNavItems = document.querySelectorAll('.mobile-bottom-nav .mobile-nav-item');
    const mobileCartBtn = document.getElementById('mobile-cart-btn');

    if (mobileCartBtn) {
        mobileCartBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            openCart();
        });
    }

    mobileNavItems.forEach(item => {
        const targetId = item.getAttribute('href');
        if (targetId && targetId.startsWith('#')) {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const targetEl = document.querySelector(targetId);
                if (targetEl) {
                    const headerOffset = 60; // Mobile header height
                    const elementPosition = targetEl.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                    
                    window.scrollTo({
                        top: offsetPosition,
                        behavior: 'smooth'
                    });
                    
                    mobileNavItems.forEach(nav => nav.classList.remove('active'));
                    item.classList.add('active');
                }
            });
        }
    });

    const sections = document.querySelectorAll('section, header, footer');
    window.addEventListener('scroll', () => {
        let currentSectionId = '';
        const scrollPosition = window.scrollY + 120; // Include header offset

        sections.forEach(section => {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;
            if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
                if (section.id) {
                    currentSectionId = '#' + section.id;
                } else if (section.tagName === 'HEADER') {
                    currentSectionId = '#hero';
                }
            }
        });

        if (currentSectionId) {
            mobileNavItems.forEach(item => {
                if (item.getAttribute('href') === currentSectionId) {
                    item.classList.add('active');
                } else {
                    item.classList.remove('active');
                }
            });
        }
    });

    // === COCKPIT VISUALIZATION VIEW TOGGLE ===
    const btnToggleCockpit = document.getElementById('btn-toggle-cockpit');
    const capCanvasWrapper = document.querySelector('.cap-canvas-wrapper');

    if (btnToggleCockpit && capCanvasWrapper) {
        btnToggleCockpit.addEventListener('click', () => {
            const isActive = capCanvasWrapper.classList.toggle('cockpit-view-active');
            if (isActive) {
                btnToggleCockpit.innerHTML = '<i class="fa-solid fa-circle-dot" style="margin-right: 0.25rem;"></i> Close Up';
                showToast('Switched to bike cockpit visualization!', 'fa-bicycle');
            } else {
                btnToggleCockpit.innerHTML = '<i class="fa-solid fa-bicycle" style="margin-right: 0.25rem;"></i> View On Bike';
                showToast('Switched back to close-up cap view.', 'fa-magnifying-glass-plus');
            }
        });
    }

    // === STARTING PRESET TEMPLATE LOADER ===
    window.loadPresetTemplate = function(presetKey, targetColor = 'black') {
        if (!canvas) return;

        // 1. Clear existing texts and decals
        canvas.getObjects().forEach(o => {
            canvas.remove(o);
        });

        // If 'none' preset, just clear canvas and return
        if (presetKey === 'none') {
            canvas.discardActiveObject();
            canvas.renderAll();
            debouncedSaveDesign();
            showToast('Canvas cleared to blank cap.', 'fa-rotate-left');
            return;
        }

        // 2. Set base finish color to target color (default Black)
        state.customizer.color = targetColor;
        const capColors = {
            black: 'Black',
            green: 'Anodized Green',
            blue: 'Electric Blue',
            gold: 'Anodized Gold',
            silver: 'Anodized Silver',
            bronze: 'Anodized Bronze',
            pink: 'Hot Pink',
            purple: 'Royal Purple',
            red: 'Cherry Red'
        };
        state.customizer.colorName = capColors[targetColor] || 'Black';

        // Sync active state on UI buttons
        document.querySelectorAll('.color-option-btn').forEach(btn => {
            if (btn.dataset.color === targetColor) {
                btn.classList.add('active');
            } else {
                btn.classList.remove('active');
            }
        });

        // Re-render base cap finish
        renderCustomizer();

        // 3. Resolve preset key SVG file and load it
        const fileName = DecalSVGFiles[presetKey];
        if (!fileName) {
            canvas.discardActiveObject();
            canvas.renderAll();
            debouncedSaveDesign();
            return;
        }

        let url = `Assets/Decals/${fileName}`;
        if (window.CappedOutAssets && window.CappedOutAssets.decals && window.CappedOutAssets.decals[presetKey]) {
            url = window.CappedOutAssets.decals[presetKey];
        }

        if (fileName.endsWith('.png') || fileName.endsWith('.jpg') || fileName.endsWith('.jpeg')) {
            showToast('Loading color design template...', 'fa-spinner fa-spin');
            fabric.Image.fromURL(url, function(img) {
                if (!img) {
                    showToast('Failed to load template design.', 'fa-triangle-exclamation');
                    return;
                }
                const TARGET_SIZE = 160;
                const rawW = img.width || 1;
                const rawH = img.height || 1;
                const scale = TARGET_SIZE / Math.max(rawW, rawH);
                
                img.set({
                    left: 135,
                    top: 135,
                    originX: 'center',
                    originY: 'center',
                    scaleX: scale,
                    scaleY: scale,
                    baseScale: scale,
                    hasControls: true,
                    hasBorders: true,
                    borderColor: '#ff0033',
                    cornerColor: '#ff0033',
                    cornerStrokeColor: '#07070a',
                    cornerStyle: 'circle',
                    cornerSize: 14,
                    touchCornerSize: 32,
                    transparentCorners: false,
                    padding: 8
                });
                
                img.decalEtchMode = 'fill';
                img.decalType = 'raster';
                
                canvas.add(img);
                canvas.setActiveObject(img);
                canvas.renderAll();
                debouncedSaveDesign();
                showToast('Template design loaded!', 'fa-paintbrush');
            });
            return;
        }

        showToast('Loading design template...', 'fa-spinner fa-spin');

        fetch(url)
            .then(res => {
                if (!res.ok) throw new Error('CORS or network error');
                return res.text();
            })
            .then(svgText => {
                fabric.loadSVGFromString(svgText, function(objects, options) {
                    const validObjects = objects.filter(obj => obj);
                    if (validObjects.length === 0) return;

                    // Use groupSVGElements to preserve relative positions within the SVG
                    const grouped = fabric.util.groupSVGElements(validObjects, options);

                    // Auto-scale to fit within the engraving area (canvas is 270x270,
                    // engravable zone is roughly 180px diameter centred at 135,135)
                    const TARGET_SIZE = 160; // px — fills most of the cap face
                    const rawW = grouped.width  || grouped.getScaledWidth()  || 1;
                    const rawH = grouped.height || grouped.getScaledHeight() || 1;
                    const scale = TARGET_SIZE / Math.max(rawW, rawH);

                    grouped.set({
                        left: 135,
                        top: 135,
                        originX: 'center',
                        originY: 'center',
                        scaleX: scale,
                        scaleY: scale,
                        baseScale: scale,
                        hasControls: true,
                        hasBorders: true,
                        borderColor: '#ff0033',
                        cornerColor: '#ff0033',
                        cornerStrokeColor: '#07070a',
                        cornerStyle: 'circle',
                        cornerSize: 14,
                        touchCornerSize: 32,
                        transparentCorners: false,
                        padding: 8
                    });

                    const etchColor = getEtchColor();
                    grouped.decalEtchMode = 'fill';
                    grouped.decalType = 'vector';

                    // Apply etch colour to group and all children
                    const applyColor = (obj) => {
                        if (obj.type === 'group') {
                            obj.forEachObject(applyColor);
                        } else {
                            if (obj.fill && obj.fill !== 'none') obj.set('fill', etchColor);
                            if (obj.stroke && obj.stroke !== 'none') obj.set('stroke', etchColor);
                        }
                    };
                    if (grouped.type === 'group') {
                        grouped.forEachObject(applyColor);
                    } else {
                        applyColor(grouped);
                    }

                    canvas.add(grouped);
                    canvas.setActiveObject(grouped);
                    canvas.renderAll();
                    debouncedSaveDesign();
                    showToast('Template design loaded!', 'fa-paintbrush');
                });
            })
            .catch(err => {
                console.error('Error loading SVG preset:', err);
                showToast('Failed to load template design.', 'fa-triangle-exclamation');
            });
    };

    // Dynamically inject "Customize This Design" buttons below the Buy buttons to avoid manual markup duplication
    document.querySelectorAll('.premade-buy-btn').forEach(buyBtn => {
        const parentDiv = buyBtn.parentElement;
        if (!parentDiv) return;

        const mainContainer = parentDiv.parentElement;
        if (!mainContainer) return;
        
        // Find if button already exists to prevent duplicate injection
        const existing = mainContainer.querySelector('.premade-customize-btn');
        if (existing) return;

        const handle = buyBtn.dataset.handle;
        if (handle === 'tubless-valves' || (handle && handle.includes('full-colour'))) return;
        
        // Style the parent div to be a flex column wrapper, and put price/buy inside a top row
        mainContainer.style.display = 'flex';
        mainContainer.style.flexDirection = 'column';
        mainContainer.style.gap = '0.75rem';

        // Create the Customize button
        const custBtn = document.createElement('button');
        custBtn.type = 'button';
        custBtn.className = 'btn btn-outline btn-sm premade-customize-btn';
        custBtn.dataset.handle = handle;
        custBtn.style.width = '100%';
        custBtn.style.padding = '0.5rem';
        custBtn.style.fontSize = '0.8rem';
        custBtn.style.borderRadius = 'var(--radius-sm)';
        custBtn.style.border = '1px solid rgba(255, 255, 255, 0.15)';
        custBtn.style.background = 'none';
        custBtn.style.color = 'var(--text-main)';
        custBtn.style.fontWeight = '600';
        custBtn.style.cursor = 'pointer';
        custBtn.style.transition = 'var(--transition)';
        custBtn.innerHTML = 'Customize This Design <i class="fa-solid fa-paintbrush" style="font-size:0.7rem; margin-left:0.25rem;"></i>';

        // Add hover effects
        custBtn.addEventListener('mouseenter', () => {
            custBtn.style.borderColor = 'var(--accent)';
            custBtn.style.backgroundColor = 'rgba(255, 0, 51, 0.05)';
        });
        custBtn.addEventListener('mouseleave', () => {
            custBtn.style.borderColor = 'rgba(255, 255, 255, 0.15)';
            custBtn.style.backgroundColor = 'transparent';
        });

        // Add click listener
        custBtn.addEventListener('click', (e) => {
            e.preventDefault();

            const handleToPresetMap = {
                'big-huck-zero-fu-ks': 'premade_big_hucks',
                'dino-game': 'premade_404',
                'fast-as-fuck': 'premade_lets_go',
                'eject-button': 'premade_eject',
                'smiley': 'premade_x_eyes',
                'all-the-gear-and-no-idea': 'premade_too_short',
                'nugz-not-drugz': 'premade_nugz',
                'just-fuckin-send-it': 'premade_send_it',
                'shit-bikes': 'premade_shut_up',
                'my-mum-says-im-cool-1': 'premade_mum_cool',
                'invader': 'premade_skull',
                'slappin-turns-roostin-berms': 'premade_slappin_turns',
                'ride-fast-eat-ass': 'premade_ride_fast_eat_ass',
                'get-on-the-beers': 'premade_get_beers',
                'look-mum-no-hands': 'premade_no_hands',
                'money-pit': 'premade_money_pit',
                'ready-to-shred': 'premade_ready_shred',
                'big-whips': 'premade_big_whips',
                'big-whips-backflips': 'premade_big_whips',
                'cookie-full-colour': 'premade_cookie',
                'donut-full-colour': 'premade_donut',
                'eyeball-full-colour': 'premade_eyeball',
                'pizza-full-colour': 'premade_pizza',
                'splatter-paint-full-colour': 'premade_splatter_paint'
            };

            const presetKey = handleToPresetMap[handle] || 'premade_big_hucks';

            // Scroll to customizer
            const customizerSec = document.getElementById('customizer');
            if (customizerSec) {
                customizerSec.scrollIntoView({ behavior: 'smooth' });
            }

            // Load preset
            if (window.loadPresetTemplate) {
                window.loadPresetTemplate(presetKey, 'black');
            }

            // Go to step 2 (etch tab)
            if (window.goToStep) {
                window.goToStep(2);
            }
        });

        mainContainer.appendChild(custBtn);
    });

    // Wire up the preset template buttons dynamically to avoid sandbox restrictions on inline onclicks
    document.querySelectorAll('.preset-item-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            const presetKey = btn.dataset.preset;
            if (presetKey && window.loadPresetTemplate) {
                window.loadPresetTemplate(presetKey, 'black');
            }
        });
    });
});
